import React, {Component} from 'react';
import axios from 'axios';
import Moment from 'react-moment';
import 'moment/locale/es';
import moment from "moment";
import fileDownload from 'js-file-download';
import * as ReactBootStrap from 'react-bootstrap';
import '../tools/css/Agendas.css';
import '../tools/css/Home.css';
import Profesionales from '../API/Profesionales';
import DiasSemana from '../API/DiasSemana';
import BtnEdit from '../components/BtnEdit';
import BtnVer from '../components/BtnVer';
import cargamultimedia from '../tools/images/iconocargarfoto.svg'
import Logo_nuevo from '../tools/images/Nuevo';
import Info from '../tools/images/Info';
import Logo_agenda from '../tools/images/Agenda';
import BtnAdd from '../components/BtnAdd';
import BtnDelete from '../components/BtnDelete';
import EstadoVacio from '../components/EstadoVacio';
import Buscar from '../tools/images/Buscar';
import file_pdf from '../tools/images/file_arrow.svg';
import Select from 'react-select';
import VideoLlamadaZego from '../components/VideoLlamadaZego';

import ReactNotifications from 'react-notifications-component';
import { store } from 'react-notifications-component';
import 'animate.css';
import 'react-notifications-component/dist/theme.css';

import $ from 'jquery'; // <-to import jquery
import 'bootstrap';

const ApiURL=process.env.REACT_APP_API_URL;
var institution_id =sessionStorage.getItem('id_institution');
var id_med_anexo =sessionStorage.getItem('identificacion_profesional');
var nom_med_anexo =sessionStorage.getItem('nombre_usua');
var token_profesional =sessionStorage.getItem('token_profesional');

// Instancia de axios aparte para GetAppointmentsProfessional: la instancia
// por defecto tiene un interceptor global (en Navbar.js) que le inyecta el
// header Authorization con el token de sesión de Medicall24 a TODAS las
// peticiones — si se usara esa misma instancia acá, ese interceptor se
// mezclaría con el Bearer de token_profesional que necesita este endpoint.
const axiosProfesional = axios.create();

// Instancia de axios aparte para el Graph API de WhatsApp/Meta: la instancia
// por defecto tiene un interceptor global (en Navbar.js) que le inyecta el
// header Authorization con el token de sesión de Medicall24 a TODAS las
// peticiones — si se usara esa misma instancia acá, ese interceptor se
// mezclaría con el Authorization Bearer de Meta que necesita este endpoint.
const axiosMeta = axios.create();

var mensaje='';
var id_profe='0';
var id_especialidad='0';
var id_sede='0';
var id_sededit='0'
var nom_sededit='';
var id_especialidad_edit='0';
var dia_intervalo='null';
var agendaid='0';
var nom_agenda='';
var buscar_agenda='';
var buscar_agenda_inactiva='';
var buscar_agenda_vencida='';
var buscar_agenda_anulada='';
var dato=0;
var btn_activar='';
var estado_agenta='';
var est_agenda='';
var id_tipo_servi=0;
var id_cita_cancela=0;
var agenda_para_cancelar=null;
var agenda_finalizar_consulta=null;
var tipo_filtro='';
var tipo_filtro_atendidos='';
var buscar_solicitada='';
var id_consulta=0;
var diagnosticos_pcte=[];
var avatar=[];
var nombre_tipoanexo="";
var file_base64_doc="";
var id_tipoanexo="0";
var id_anexo_elimina=0
var token_institucion =sessionStorage.getItem('token');
var id_profeiframe=sessionStorage.getItem('codigo_med');
var url_iframe=process.env.REACT_APP_IFRAME_URL+"/agenda-profesional-nueva-estructura?token="+token_profesional+"&idProfesional="+id_profeiframe+"&identificacion="+id_med_anexo+"&tokenInstitucion="+token_institucion+"&idInstitucion="+institution_id

const diagnosticos_hc=[]



class Agenda_profesional_2 extends Component {

  videoLlamadaRef = React.createRef();

  constructor()
    {
     super()
      this.state={
        Horario: [], 
        Parametro:[],
        Agendas: [],         
        Pager_Agendas: [],
        pager_infoagendas:'', 
        Agendas_inactivas: [],         
        Pager_Agendas_inactivas: [],
        pager_infoagendas_inactivas:'', 
        Agendas_vencidas: [],         
        Pager_Agendas_vencidas: [],
        pager_infoagendas_vencidas:'',
        Agendas_anulada: [],         
        Pager_Agendas_anulada: [],
        Diagnotico_Multiple:[],
        Diagnotico_Multiple_edit:[],
        Diagnostico_hc:[],
        pager_infoagendas_anulada:'',
        loading: false,
        Sedes:[] ,
        profesionales: [],
        IntervaloAgenda: [],
        Especialidades:[],
        Servicios: [],
        Tipo_anexos:[],
        Historia:[],
        Historial_anexos:[],
        idCitaModalHc: null,
        cargandoIframeAgendaHc: false,
        loading_button: true,
        active_button: true,
        loading_button_cancelacita: true,
        active_button_cancelacita: true,
        loading_button_whatsapp_cancelacion: true,
        active_button_whatsapp_cancelacion: true,
        formWhatsappCancelacion:{
          nombre:'',
          hora:'',
          fecha:'',
          especialidad:'',
          tipoCita:'',
          institucion:'',
          celular:''
        },
        active: true,
        loading_button_intervalo: true,
        active_button_intervalo: true,
        loading_button_eliminar: true,
        active_button_eliminar: true,
        loading_btnaddanexo: true,
        active_btnaddanexo: true,
        loading_btnhisanexo: true,
        active_btnhisanexo: true,
        loading_button_eliminaanexo:true,
        active_button_eliminaanexo:true,
        active_check:true,
        form:{ 
          nom_agenda: '',         
          fecha_ini:'',
          fecha_fin:'',
          id_agenda_edit:'',
          nom_agenda_edit:'',
          fechaini_edit:new Date,
          fechafin_edit:new Date,
          inicio:'',
          fin:'',
          intervalo:'',
          espe:'0',
          buscar_agendas:'',
          buscar_agendas_inactiva:'',

          id_cita:'',
          id_pacie_soli:'',
          tipoid_pacien_hc:'',
          id_pacien_hc:'',
          nom1_pacien:'',
          nom2_pacien:'',
          apell1_pacien:'',
          apell2_pacien:'',
          obser:'',
          fecha_cita:'',
              
          espe_soli:'',
              
          fecha_naci:'',
          edad_pcte:'',
          genero_pcte:'',
          dir_pcte:'',
          tel_pcte:'',
          municipio_pcte:'',
          departamento_pct: '',
          responsable_pcte:'',
          telresponsable_pcte:'',
          parentescoresp_pcte:'',
          eps_pcte:'',
          regimen_pcte:'',
          email_pcte:'', 
          
          idconsulta:'',
          id_paciente:'',
          nom_pctehc:'',
          eps:'',

          acompanante:'',
          tel_acompanante:'',
          motivo_consulta:'',
          enfermada_actual:'',
          antecedentes_rel:'',
          revision_sistema:'',
          examen_fis:'',
          analisis:'',
          conducta:'',
          formula_med:'',
          orden_med:'',

          nombre_anexo:'',
          descripcion_anexo:'',
          num_file:'Ningún archivo seleccionado'
          

          }
      }
    }

    Selectdrop(){
      if(id_profe=='0' && this.state.form.fecha_ini!=''){
        $("#api_profesional").val($('#api_profesional > option:first').val()); 
      }
    }

    handlerSelectdrop(){

      $("#nom_agenda").val("");
      $("#fecha_ini").val("");
      $("#fecha_fin").val("");
      $("#profesionales").val($('#profesionales > option:first').val());
      $("#sede").val($('#sede > option:first').val());
      $("#espe").val($('#espe > option:first').val());
      $("#div_agenda1").find("*").prop('disabled', false);
      $("#div_agenda2").find("*").prop('disabled', false);
      $("#div_agenda3").find("*").prop('disabled', false);

      id_profe='0';
      id_especialidad='0';
      id_sede='0';

      this.setState({Especialidades: []})
     
    }

      handleModalrespuestacitadrop()
        {
          $('#modal-consulta').on('show.bs.modal', function (event) {
            $("#modal-consulta input").val("");
            $("#modal-consulta textarea").val("");
            $("#modal-consulta select").val("Seleccione...");
            
        });

        
          this.setState({
            form:{
            nombre_anexo:'',
            descripcion_anexo:'',
          }
        })

        this.setState({num_file:'Ningún archivo seleccionado'})
    
          
          file_base64_doc="";
          id_tipoanexo="0";

          this.getDiagnoticos();

      }


      handleModaldetallehcdrop()
        {
          $('#modal-imprimirconsulta').on('show.bs.modal', function (event) {
            $("#modal-imprimirconsulta input").val("");
            $("#modal-imprimirconsulta textarea").val("");
            $("#modal-imprimirconsulta select").val("Seleccione...");
            
        });

        
        this.setState({
            form:{
            nombre_anexo:'',
            descripcion_anexo:'',
            id_paciente:''
          }
        })

        this.setState({num_file:'Ningún archivo seleccionado'})
    
          
          file_base64_doc="";
          id_tipoanexo="0";

          this.getDiagnoticos();

      }
      

    handlerdropIntervalo(){


      $("#inicio").val("");
      $("#fin").val("");
      $("#dia_agenda").val($('#dia_agenda > option:first').val());
      $("#tipo_servicio").val($('#tipo_servicio > option:first').val());
      $("#intervalo").val("");
      

      dia_intervalo='null';
      id_tipo_servi=0;
     
     
     
    }

   
    handleChange=async e=>{
      await this.setState({
         form:{
              ...this.state.form,
              [e.target.name]: e.target.value
              }
         })
         console.log(this.state.form);    
         this.Selectdrop();     
    }

    Campo_numerico(){
      $(".camponum").keypress(function(tecla)
      {
        if(tecla.charCode<48 || tecla.charCode>57){
         
          return false;

        }
      })
    }

    componentDidMount(){

      $('[data-toggle="tooltip"]').tooltip()

      $('#filtrar_agenda').hide(); 
      $('#select_modalidad_filtro').hide(); 
      $('#select_tipoconsulta_filtro').hide(); 
      $('#texto_filtro').hide();

      $('#filtrar_atendidos').hide(); 
      $('#select_modalidad_filtro_atendidos').hide(); 
      $('#select_tipoconsulta_filtro_atendidos').hide(); 
      $('#texto_id_pcte').hide();

      this.CargarAgendas(); 
      this.getDiagnoticos();    
      this.Cargar_Tipo_Anexo();

    }


    empty_page_hide(){
      $('#tabla1').hide();     
      $('#empty_page').hide();
      $('#text_page').hide();

      $('#tabla2').hide();     
      $('#empty_page2').hide();
      $('#text_page2').hide();

      $('#tabla3').hide();     
      $('#empty_page3').hide();
      $('#text_page3').hide();

      $('#tabla4').hide();     
      $('#empty_page4').hide();
      $('#text_page4').hide();
      
    }

    modal_informacionpcte(){
         
          $('#modal-infopcte').modal('show');
         
    }

    Traerdato_Cancelar_cita(agenda){
          id_cita_cancela  = agenda.id;
          agenda_para_cancelar = agenda;

          $('#modal-cancela_cita').modal('show'); // <- to show modal elimiinar intervalo

    }

    // agenda.consultations es un arreglo (a veces vacío []); esto trae la
    // consulta más reciente (la última del arreglo) cuando hay datos.
    ultimaConsulta = (agenda) => {
      if(!agenda || !agenda.consultations || !agenda.consultations.length) return null;
      return agenda.consultations[agenda.consultations.length - 1];
    }

    estadoUltimaConsulta = (agenda) => {
      const ultimaConsulta = this.ultimaConsulta(agenda);
      return (ultimaConsulta && ultimaConsulta.status) ? ultimaConsulta.status : '';
    }

    // El ícono de videollamada solo se habilita cuando aún no hay ninguna
    // consulta (consultations vacío []) o cuando la última quedó "fallida".
    videollamadaHabilitada = (agenda) => {
      if(!agenda || !agenda.consultations || !agenda.consultations.length) return true;
      return (this.estadoUltimaConsulta(agenda)||'').trim().toLowerCase()==='fallida';
    }

    // Cuando la última consulta quedó en estado "atendida", el botón de
    // "Realizar historia clínica" en vez de abrir el modal directamente
    // pregunta primero si la consulta fue exitosa o fallida.
    AbrirModalComoTerminoConsulta = (agenda) => {
      agenda_finalizar_consulta = agenda;
      $('#modal-como-termino-consulta').modal('show');
    }

    // complete=true -> Exitosa, complete=false -> Fallida.
    CerrarConsulta = (complete) => {
      const ultimaConsulta = this.ultimaConsulta(agenda_finalizar_consulta);
      if(!ultimaConsulta || !ultimaConsulta.id) return;

      axiosProfesional.put(ApiURL+"/api/Consultations/Close",
        {
          consultationId: ultimaConsulta.id,
          complete: complete
        },
        { headers: { "Authorization": "Bearer "+token_profesional } }
      )
      .then((response) => {
        console.log(response.data)

        store.addNotification({
          title: 'Muy bien',
          message: complete ? 'Consulta marcada como exitosa.' : 'Consulta marcada como fallida.',
          type: 'success',
          container: 'top-right',
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 8000, showIcon:true }
        })

        $('#modal-como-termino-consulta').modal('hide');
        this.CargarAgendas();
      })
      .catch((error) => {
        const mensajeError = (error.response && error.response.data && error.response.data.message) || 'No se pudo actualizar la consulta';

        store.addNotification({
          title: 'Atención',
          message: mensajeError,
          type: 'danger',
          container: 'top-right',
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 10000, showIcon:true }
        })
      })
    }

    MarcarConsultaExitosa = () => {
      this.CerrarConsulta(true);
    }

    MarcarConsultaFallida = () => {
      this.CerrarConsulta(false);
    }

    handleModal_realizahc()
    {      
      $('#modal-consulta').modal('show'); // <- to show modal editar contrato       
    }

    handleModalconsultashow()
    {      
      $('#modal-imprimirconsulta').modal('show'); // <- to show modal editar contrato       
    }

    handleModalhistorialanexo()
    {     
      $('#modal-historial_anexo').modal('show'); // <- to show modal historial de citas 
      
    }

    Traerdato_historial_anexo(historial){
          id_anexo_elimina  = historial.id;

          if (historial.profesionalId == id_med_anexo){

             $('#modal-elimina_anexo').modal('show'); // <- to show modal elimiinar intervalo

          }else{
            
                store.addNotification({
                  title: 'Atención',
                  message: "No tiene permiso para eliminar el anexo",
                  type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })

          }
    
          
    
    }

   

    seleccionarconsulta_agendahc=(agenda)=>{

      //this.Crear_consulta(agenda.id);

          this.setState({
              form:{
              id_cita:agenda.id,
              idconsulta:id_consulta, 
              id_paciente:agenda.patient.user.typeId +'-'+ agenda.patient.user.identification,
              nom_paciente: agenda.patient.user.name1 ? agenda.patient.user.name1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              nom2_paciente: agenda.patient.user.name2 ? agenda.patient.user.name2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              apell1_paciente: agenda.patient.user.lastname1 ? agenda.patient.user.lastname1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              apell2_paciente: agenda.patient.user.lastname2 ? agenda.patient.user.lastname2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',

              eps:agenda.contract.entity.name.toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))),

              acompanante:this.state.form.acompanante,
              tel_acompanante:this.state.form.tel_acompanante,
              motivo_consulta:this.state.form.motivo_consulta,
              enfermada_actual:this.state.form.enfermada_actual,
              antecedentes_rel:this.state.form.antecedentes_rel,
              revision_sistema:this.state.form.revision_sistema,
              examen_fis:this.state.form.examen_fis,
              analisis:this.state.form.analisis,
              conducta:this.state.form.conducta,
              formula_med:this.state.form.formula_med,
              orden_med:this.state.form.orden_med


            },
            idCitaModalHc: agenda.id,
            cargandoIframeAgendaHc: true
          }, () => {
            $('#custom-tabs-three-agenda_inactiva-tab').tab('show');
            //$('#modal-hc-iframe').modal('show');
          })
          //var  dato  = solicitud.user.identification;
          //alert(Historia);
    }

    seleccionarconsulta=(Agendas_inactivas)=>{

          id_consulta=Agendas_inactivas.id
          this.setState({ Historia:Agendas_inactivas.consultationData })
          this.setState({Diagnostico_hc: Agendas_inactivas.diagnostic})
          //this.saverecurso(id_consulta);

          this.setState({
              form:{
              idconsulta:Agendas_inactivas.id, 
              id_paciente:Agendas_inactivas.patient.user.typeId +'-'+ Agendas_inactivas.patient.user.identification,
              nom_paciente: Agendas_inactivas.patient.user.name1 ? Agendas_inactivas.patient.user.name1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              nom2_paciente: Agendas_inactivas.patient.user.name2 ? Agendas_inactivas.patient.user.name2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              apell1_paciente: Agendas_inactivas.patient.user.lastname1 ? Agendas_inactivas.patient.user.lastname1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              apell2_paciente: Agendas_inactivas.patient.user.lastname2 ? Agendas_inactivas.patient.user.lastname2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',

              eps:Agendas_inactivas.appointment.contract.entity.name.toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))),
              
            }
          })
          //var  dato  = solicitud.user.identification;
          //alert(Historia);
    }

    seleccionarconsulta_hc=(Agendas_inactivas)=>{

          id_consulta=Agendas_inactivas.id
          

          this.setState({
              form:{
              idconsulta:Agendas_inactivas.id, 
              id_paciente:Agendas_inactivas.patient.user.typeId +'-'+ Agendas_inactivas.patient.user.identification,
              nom_paciente: Agendas_inactivas.patient.user.name1 ? Agendas_inactivas.patient.user.name1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              nom2_paciente: Agendas_inactivas.patient.user.name2 ? Agendas_inactivas.patient.user.name2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              apell1_paciente: Agendas_inactivas.patient.user.lastname1 ? Agendas_inactivas.patient.user.lastname1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              apell2_paciente: Agendas_inactivas.patient.user.lastname2 ? Agendas_inactivas.patient.user.lastname2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',

              eps:Agendas_inactivas.appointment.contract.entity.name.toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))),
              
            }
          })
          //var  dato  = solicitud.user.identification;
          //alert(Historia);
    }

    Get_id_tipoanexo = (ta) =>{
    //this.setState({tipoid:id.target.value})
    console.log(ta.target.value)
    id_tipoanexo=(ta.target.value) 

    nombre_tipoanexo=this.state.Tipo_anexos.filter(item => item.id == id_tipoanexo)[0].name
    //alert(nombre_tipoanexo)    
    
    }

    GetDoc= (i) =>{  

    avatar=i.target.files[0]
    let reader = new FileReader();
    reader.readAsDataURL(avatar);
    reader.onloadend =  () => {
      
      file_base64_doc = (reader.result).split(',')[1];
      this.setState({num_file:"Ha seleccionado "+(i.target.files.length)+" archivo(s)"})
      //num_file="Ha seleccionado "+(i.target.files.length)+" archivo(s)"
    
      //alert(base64data)
      //console.log(file_base64_doc)   
      //console.log(tipo_file_base64_doc) 
     
    } 

    //this.Sweetaler_subir_documento();
    //files_view=URL.createObjectURL(i.target.files[0]);
    
    //$('#modal_documento').modal('show');
    //alert(avatar)
  }

    descargar_consulta=async()=>{        
    
            this.setState({ loading_button: this.state.loading_button = false })
            this.setState({ active_button: this.state.active_button = false })
            //$('#modal-loader').modal('show') // <- to show modal descarga video
            //$('#modal-consulta').modal('hide') // <- to show modal descarga video
    
            await axios.get(ApiURL+"/api/Consultations/PrintConsultation/"+id_consulta,{            
              
              responseType:'blob'
    
            })  
        
            .then(response=>{
              
              fileDownload(response.data,'Consultation-'+id_consulta+'.pdf')
              const blob = new Blob([response.data], { type: 'application/pdf' })
              const objectUrl = window.URL.createObjectURL(blob)
              window.open(objectUrl)
              
              store.addNotification({
                title: 'Mensaje',
                message: "El documento ha sido descargado",
                type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                container: 'top-right',                // where to position the notifications
                animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                dismiss: {
                  duration: 10000,
                  showIcon:true
                }
              })
    
              this.setState({ loading_button: this.state.loading_button = true })
              this.setState({ active_button: this.state.active_button = true })
              //this.handleModalarecurdodrop();   
              
            })
            .catch((error)=>{
    
              if (error.response) {
    
                console.log(error.response);
                mensaje=error.message;                    
    
                store.addNotification({
                  title: 'Atención',
                  message: "No se encontró información",
                  type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })            
                
                this.setState({ loading_button: this.state.loading_button = true })
                this.setState({ active_button: this.state.active_button = true })
                //this.handleModalrecursodrop(); 
      
              } else if (error.request) {
                  /*
                   * The request was made but no response was received, `error.request`
                   * is an instance of XMLHttpRequest in the browser and an instance
                   * of http.ClientRequest in Node.js
                   */
                  console.log(error.request);
              } else {
                  // Something happened in setting up the request and triggered an Error
                  console.log('Error', error.message);
              }
              //console.log(error.config);            
              
          })    
        
    }
    
    
    descargar_formula=async()=>{        
    
          this.setState({ loading_button: this.state.loading_button = false })
          this.setState({ active_button: this.state.active_button = false })
          //$('#modal-loader').modal('show') // <- to show modal descarga video
          //$('#modal-consulta').modal('hide') // <- to show modal descarga video
    
          await axios.get(ApiURL+"/api/Consultations/PrintMedicalPrescription/"+id_consulta,{            
            
            responseType:'blob'
    
          })  
      
          .then(response=>{
            
            fileDownload(response.data,'Formula-'+id_consulta+'.pdf')
            const blob = new Blob([response.data], { type: 'application/pdf' })
            const objectUrl = window.URL.createObjectURL(blob)
            window.open(objectUrl)
             
            
            store.addNotification({
              title: 'Mensaje',
              message: "El documento ha sido descargado",
              type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
              container: 'top-right',                // where to position the notifications
              animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
              animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
              dismiss: {
                duration: 10000,
                showIcon:true
              }
            }) 
            
            this.setState({ loading_button: this.state.loading_button = true })
            this.setState({ active_button: this.state.active_button = true })
            //$('#modal-loader').modal('hide');
            
          })
          .catch((error)=>{
    
            if (error.response) {
    
            console.log(error.response);
            mensaje=error.message;                    
    
            store.addNotification({
              title: 'Atención',
              message: "No se encontró información",
              type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
              container: 'top-right',                // where to position the notifications
              animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
              animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
              dismiss: {
                duration: 10000,
                showIcon:true
              }
            })            
            
            this.setState({ loading_button: this.state.loading_button = true })
            this.setState({ active_button: this.state.active_button = true })
            //this.handleModalrecursodrop(); 
    
          } else if (error.request) {
              /*
               * The request was made but no response was received, `error.request`
               * is an instance of XMLHttpRequest in the browser and an instance
               * of http.ClientRequest in Node.js
               */
              console.log(error.request);
          } else {
              // Something happened in setting up the request and triggered an Error
              console.log('Error', error.message);
          }
          //console.log(error.config);                       
            
        })  
      
          }
    
    
    descargar_orden=async()=>{        
    
        this.setState({ loading_button: this.state.loading_button = false })
        this.setState({ active_button: this.state.active_button = false })
        //$('#modal-loader').modal('show') // <- to show modal descarga video
        //$('#modal-consulta').modal('hide') // <- to show modal descarga video
    
        await axios.get(ApiURL+"/api/Consultations/PrintMedicalOrder/"+id_consulta,{            
          
          responseType:'blob'
    
        })  
    
        .then(response=>{
          
          fileDownload(response.data,'Orden-'+id_consulta+'.pdf')
          const blob = new Blob([response.data], { type: 'application/pdf' })
          const objectUrl = window.URL.createObjectURL(blob)
          window.open(objectUrl)
     
          
          store.addNotification({
            title: 'Mensaje',
            message: "El documento ha sido descargado",
            type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
            container: 'top-right',                // where to position the notifications
            animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
            animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
            dismiss: {
              duration: 10000,
              showIcon:true
            }
          })   
          
          this.setState({ loading_button: this.state.loading_button = true })
          this.setState({ active_button: this.state.active_button = true })
          //$('#modal-loader').modal('hide');
          
        })
        .catch((error)=>{
    
          if (error.response) {
    
          console.log(error.response);
          mensaje=error.message;                    
    
          store.addNotification({
            title: 'Atención',
            message: "No se encontró información",
            type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
            container: 'top-right',                // where to position the notifications
            animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
            animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
            dismiss: {
              duration: 10000,
              showIcon:true
            }
          })            
          
          this.setState({ loading_button: this.state.loading_button = true })
          this.setState({ active_button: this.state.active_button = true })
    
        } else if (error.request) {
            /*
             * The request was made but no response was received, `error.request`
             * is an instance of XMLHttpRequest in the browser and an instance
             * of http.ClientRequest in Node.js
             */
            console.log(error.request);
        } else {
            // Something happened in setting up the request and triggered an Error
            console.log('Error', error.message);
        }
        //console.log(error.config);                       
          
      })
    
    
    }


    async getDiagnoticos(){
            const res = await axios.get(process.env.REACT_APP_API_URL+'/api/TypeServices')
            const data = res.data
        
            /*const options = data.map(d => ({
              "value" : d.id,
              "label" : d.name
        
            }))*/

            
            const options = diagnosticos_hc.map(d => ({
              "value" : d.cod_dx,
              "label" : d.nombre_dx
        
            }))
        
            this.setState({Diagnotico_Multiple: options})
        
    }

    async getDiagnoticos_edit(dato){
           
        
            /*const options = data.map(d => ({
              "value" : d.id,
              "label" : d.name
        
            }))*/

            
            const options = dato.map(d => ({
              "value" : d.id,
              "label" : d.nombre_dx
        
            }))
        
            this.setState({Diagnotico_Multiple_edit: options})
        
    }


    Gettipo_filtro = (tf) =>{
          //this.setState({tipoid:id.target.value})
          $("#modalidad_filtro").val($('#sede_filtro > option:first').val());
          $("#tipoconsulta_filtro").val($('#tipoconsulta_filtro > option:first').val());      
          $("#buscar_solicitadas").val("");  
          console.log(tf.target.value)
          tipo_filtro=(tf.target.value)
          
          if(tipo_filtro=="1"){
            $('#select_modalidad_filtro').show(); 
            $('#select_tipoconsulta_filtro').hide(); 
            $('#texto_filtro').hide();
            
            $('#texto_filtro').hide();
          }
            if(tipo_filtro=="2"){
              $('#texto_filtro').hide();
              $('#select_modalidad_filtro').hide(); 
              $('#select_tipoconsulta_filtro').show(); 
              
            }
            if(tipo_filtro=="3"){
              $('#texto_filtro').show();
              $('#select_modalidad_filtro').hide(); 
              $('#select_tipoconsulta_filtro').hide(); 
              buscar_solicitada=""; 
              //this.searchDatasolcitada(buscar_solicitada)   
            }
            
            if(tipo_filtro=="10"){
              $('#texto_filtro').hide();
              $('#select_modalidad_filtro').hide(); 
              $('#select_tipoconsulta_filtro').hide(); 
              buscar_solicitada=""; 
              //this.searchDatasolcitada(buscar_solicitada)   
            } 
        }
        

    Gettipo_filtro_atendidos = (fa) =>{
          //this.setState({tipoid:id.target.value})
          $("#modalidad_filtro_atendidos").val($('#sede_filtro > option:first').val());
          $("#modalidad_filtro_atendidos").val($('#modalidad_filtro_atendidos > option:first').val());      
          $("#modalidad_filtro_atendidos").val("");  
          console.log(fa.target.value)
          tipo_filtro_atendidos=(fa.target.value)
          
          if(tipo_filtro_atendidos=="1"){
            $('#select_modalidad_filtro_atendidos').show(); 
            $('#select_tipoconsulta_filtro_atendidos').hide(); 
            $('#texto_id_pcte').hide();
            
          
          }
            if(tipo_filtro_atendidos=="2"){
              $('#texto_id_pcte').hide();
              $('#select_modalidad_filtro_atendidos').hide(); 
              $('#select_tipoconsulta_filtro_atendidos').show(); 
              
            }
            if(tipo_filtro_atendidos=="3"){
              $('#texto_id_pcte').show();
              $('#select_modalidad_filtro_atendidos').hide(); 
              $('#select_tipoconsulta_filtro_atendidos').hide(); 
              buscar_solicitada=""; 
              //this.searchDatasolcitada(buscar_solicitada)   
            }
            
            if(tipo_filtro_atendidos=="10"){
              $('#texto_id_pcte').hide();
              $('#select_modalidad_filtro_atendidos').hide(); 
              $('#select_tipoconsulta_filtro_atendidos').hide(); 
              buscar_solicitada=""; 
              //this.searchDatasolcitada(buscar_solicitada)   
            } 
        }

    Buscar_atenciones_idpcte = (bs) =>{
      console.log(bs.target.value)
      var buscar_atenciones_idpcte=(bs.target.value)
      //alert(buscar_atenciones_idpcte)
      this.searchDataagenda(buscar_atenciones_idpcte)
     
    }


    seleccionar_cita=(agenda)=>{
          var citaid=agenda.id
        
          this.setState({
            form:{
              id_cita:agenda.id,
              id_pacie_soli:agenda.patient.user.typeId +'-'+ agenda.patient.user.identification,
              tipoid_pacien_hc:agenda.patient.user.typeId,
              id_pacien_hc:agenda.patient.user.identification,
              nom1_pacien:agenda.patient.user.name1 ? agenda.patient.user.name1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              nom2_pacien:agenda.patient.user.name2 ? agenda.patient.user.name2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '' ,
              apell1_pacien:agenda.patient.user.lastname1 ? agenda.patient.user.lastname1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))): '',
              apell2_pacien:agenda.patient.user.lastname2 ? agenda.patient.user.lastname2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))): '',
              obser:'',
              fecha_cita:moment(agenda.fecha).format("DD/MM/YYYY HH:mm"),
              
              espe_soli:agenda.specialty.name.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))),
              
              fecha_naci:moment(agenda.patient.user.birthday).format("DD/MM/YYYY"),
              edad_pcte:moment(agenda.patient.user.birthday).toNow(true),
              genero_pcte:agenda.patient.user.gender,
              dir_pcte:agenda.patient.user.address,
              tel_pcte:agenda.patient.user.phone,
              municipio_pcte:agenda.patient.user.municipality.nombre ? agenda.patient.user.municipality.nombre.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))): '',
              departamento_pct: agenda.patient.user.department.nombre ? agenda.patient.user.department.nombre.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              responsable_pcte:agenda.patient.user.personInCharge,
              telresponsable_pcte:agenda.patient.user.phonePerson,
              parentescoresp_pcte:agenda.patient.user.relationshipPerson,
              eps_pcte:agenda.contract.entity.razonSocial,
              regimen_pcte:agenda.patient.regimen.nombre ? agenda.patient.regimen.nombre : '',
              email_pcte:agenda.patient.user.email
              
            }
          })
          //var  dato  = solicitud.user.identification;
          //alert(cita_proce.fecha);
    
          
          axios.get(ApiURL+"/api/Citas/GetAppointment/"+citaid)
          .then((response) => {
            console.log(response);
            this.setState({Autorizacion: response.data.authorizations})
              
          })
          .catch((error) => {
            console.log(error);
          })
         
        }


    seleccionar_cita2=(agenda_inactiva)=>{
          //var citaid=agenda.id
        
          this.setState({
            form:{
              id_cita:agenda_inactiva.appointmentId,
              id_pacie_soli:agenda_inactiva.patient.user.typeId +'-'+ agenda_inactiva.patient.user.identification,
              tipoid_pacien_hc:agenda_inactiva.patient.user.typeId,
              id_pacien_hc:agenda_inactiva.patient.user.identification,
              nom1_pacien:agenda_inactiva.patient.user.name1 ? agenda_inactiva.patient.user.name1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              nom2_pacien:agenda_inactiva.patient.user.name2 ? agenda_inactiva.patient.user.name2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '' ,
              apell1_pacien:agenda_inactiva.patient.user.lastname1 ? agenda_inactiva.patient.user.lastname1.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))): '',
              apell2_pacien:agenda_inactiva.patient.user.lastname2 ? agenda_inactiva.patient.user.lastname2.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))): '',
              obser:'',
              fecha_cita:moment(agenda_inactiva.appointment.fecha).format("DD/MM/YYYY HH:mm"),
              
              //espe_soli:agenda_inactiva.specialty.name.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))),
              
              fecha_naci:moment(agenda_inactiva.patient.user.birthday).format("DD/MM/YYYY"),
              edad_pcte:moment(agenda_inactiva.patient.user.birthday).toNow(true),
              genero_pcte:agenda_inactiva.patient.user.gender,
              dir_pcte:agenda_inactiva.patient.user.address,
              tel_pcte:agenda_inactiva.patient.user.phone,
              //municipio_pcte:agenda_inactiva.patient.user.municipality.nombre ? agenda_inactiva.patient.user.municipality.nombre.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))): '',
              //departamento_pct: agenda_inactiva.patient.user.department.nombre ? agenda_inactiva.patient.user.department.nombre.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '',
              responsable_pcte:agenda_inactiva.patient.user.personInCharge,
              telresponsable_pcte:agenda_inactiva.patient.user.phonePerson,
              parentescoresp_pcte:agenda_inactiva.patient.user.relationshipPerson,
              eps_pcte:agenda_inactiva.appointment.contract.entity.razonSocial,
              regimen_pcte:agenda_inactiva.patient.regimen.nombre ? agenda_inactiva.patient.regimen.nombre : '',
              email_pcte:agenda_inactiva.patient.user.email


              
            }
          })
          var  dato  = agenda_inactiva.diagnostic;
          //alert(cita_proce.fecha);
          
          //this.getDiagnoticos_edit(dato);
          
         
        }



    Cargar_sedes(){    
    
      axios.get(ApiURL+"/api/Sedes/ListAll")
      .then((response) => {
        console.log(response);
        this.setState({Sedes: response.data})

        if(this.state.Sedes.length==0){

          $('#modal-verifisede').modal('show');
       
        }else{

          
        }


      })
      .catch((error) => {
        console.log(error);
      })
    }


    CargarAgendas(){  

      this.empty_page_hide();

      this.setState({ loading: this.state.loading = false })
      axiosProfesional.get(ApiURL+"/api/Citas/GetAppointmentsProfessional", { headers: { "Authorization": "Bearer "+token_profesional } })
      .then((response) => {

        console.log(response);
        this.setState({Agendas: response.data})
        

        if(this.state.Agendas.length==0){

          $('#tabla1').hide();
          $('#empty_page').show();
          $('#text_page').show();   
          
        }else{

          $('#tabla1').show();
          $('#empty_page').hide();
          $('#text_page').hide(); 
          
        }

        this.setState({ loading: this.state.loading = true })
      })
      .catch((error) => {
        console.log(error);
      })
    }


    CargarAgendas_busquedapcte(buscar_atenciones_idpcte){  

      //this.empty_page_hide();

      this.setState({ loading: this.state.loading = false })
      axiosProfesional.get(ApiURL+"/api/Citas/GetAppointmentsProfessional", { headers: { "Authorization": "Bearer "+token_profesional } })
      .then((response) => {

        console.log(response);
        this.setState({Agendas: response.data.filter(item => item.patient.user.identification.includes(buscar_atenciones_idpcte) )})
        

        if(this.state.Agendas.length==0){

          $('#tabla1').hide();
          $('#empty_page').show();
          $('#text_page').show();   
          
        }else{

          $('#tabla1').show();
          $('#empty_page').hide();
          $('#text_page').hide(); 
          
        }

        this.setState({ loading: this.state.loading = true })
      })
      .catch((error) => {
        console.log(error);
      })
    }


    Cargar_Tipo_Anexo(){    
        
          axios.get(ApiURL+"/api/Attach/GetTypeAttachs")
          .then((response) => {
            console.log(response.data);
            this.setState({Tipo_anexos: response.data})
            //this.setState({Tipo_anexos: response.data.filter(item => item.id !== 1)})
          })
          .catch((error) => {
            console.log(error);
          })
    }


    Subir_Anexo=async()=>{     
    
          var idpaciente =this.state.form.id_paciente.slice(3);     
          var fecha_anexo=moment().format('DD-MM-YYYY')
          //alert(fecha_anexo)

          if(nom_med_anexo.length==0 ||id_med_anexo.length==0 || file_base64_doc=="" || id_tipoanexo=="0" ){
    
            store.addNotification({
              title: 'Atención',
              message: "Faltan datos para subir el anexo",
              type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
              container: 'top-right',                // where to position the notifications
              animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
              animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
              dismiss: {
                duration: 10000,
                showIcon:true
              }
            })
    
          }else{
            this.setState({ loading_btnaddanexo: this.state.loading_btnaddanexo = false })
            this.setState({ active_btnaddanexo: this.state.active_btnaddanexo = false })
            await axios.post(ApiURL+"/api/Attach/Create",
      
              {
    
              typeAttachId: id_tipoanexo,
              patientId: idpaciente,
              patientName: this.state.form.nom_paciente +" "+ this.state.form.nom2_paciente +" "+ this.state.form.apell1_paciente +" "+ this.state.form.apell2_paciente ,
              institutionId: 1,
              fileBase64:file_base64_doc,
              name: nombre_tipoanexo +" "+ fecha_anexo,
              description: this.state.form.descripcion_anexo,
              profesionalId: id_med_anexo,
              profesionalName: nom_med_anexo
              
              })  
            .then(response=>{
              console.log(response.data)
              var  mensaje  = response.data.message;
              //alert(mensaje);
              //const [text, setText] = LocalStorage(text, '')
              //setText(dato);
                     
              //window.location.href="/home";
            store.addNotification({
                title: 'Muy bien',
                message: mensaje,
                type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                container: 'top-right',                // where to position the notifications
                animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                dismiss: {
                duration: 10000,
                showIcon:true
                }
              })
    
              this.setState({ loading_btnaddanexo: this.state.loading_btnaddanexo = true })
              this.setState({ active_btnaddanexo: this.state.active_btnaddanexo = true })
              //this.setState({ active: this.state.active = false })
    
              this.setState({
                form:{
                nombre_anexo:'',
                descripcion_anexo:'',
                id_paciente:this.state.form.id_paciente
                  }
                })

              this.setState({num_file:'Ningún archivo seleccionado'})
          
                
                file_base64_doc="";
                id_tipoanexo="0";
  
              
            })
            .catch(error=>{
             
              if (error.response) {
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                //console.log(error.response.data.message);
                //console.log(error.response.status);
                //console.log(error.response.headers);
                mensaje=error.response.data.message
                
                store.addNotification({
                  title: 'Atención',
                  message: mensaje,
                  type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })
    
              this.setState({ loading_btnaddanexo: this.state.loading_btnaddanexo = true })
              this.setState({ active_btnaddanexo: this.state.active_btnaddanexo = true })
    
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                console.log(error.request);
    
                this.setState({ loading_btnaddanexo: this.state.loading_btnaddanexo = false })
                this.setState({ active_btnaddanexo: this.state.active_btnaddanexo = false })
            } else {
                // Something happened in setting up the request and triggered an Error
                console.log('Error', error.message);
                this.setState({ loading_btnaddanexo: this.state.loading_btnaddanexo = true })
                this.setState({ active_btnaddanexo: this.state.active_btnaddanexo = true })
            }
            //console.log(error.config);
          
            })    
          }     
      }


      Historial_Anexos=async()=>{

        var idpaciente =this.state.form.id_paciente.slice(3);
        //alert(idpaciente)
      
            this.setState({ loading_btnhisanexo: this.state.loading_btnhisanexo = false })
            this.setState({ active_btnhisanexo: this.state.active_btnhisanexo = false })
      
            axios.get(ApiURL+"/api/Attach/GetAttachsPatient/"+idpaciente+"?numeroPagina=1")

              .then((response) => {
                console.log(response.data)      
                
                this.setState({ loading_btnhisanexo: this.state.loading_btnhisanexo = true })
                this.setState({ active_btnhisanexo: this.state.active_btnhisanexo = true })
      
                this.setState({Historial_anexos: response.data.data})   
                
                if(this.state.Historial_anexos.length==0){
      
                  store.addNotification({
                    title: 'Atención',
                    message: 'El paciente no tiene anexos relacionados',
                    type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                    container: 'top-right',                // where to position the notifications
                    animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                    animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                    dismiss: {
                      duration: 10000,
                      showIcon:true
                    }
                  })
      
                }else{
      
                  this.handleModalhistorialanexo();
                  //alert("Con anexos")
      
                }
               
                
                
              })
              .catch(error=>{
                
                if (error.response) {
                  /*
                   * The request was made and the server responded with a
                   * status code that falls out of the range of 2xx
                   */
                  //console.log(error.response.data.message);
                  //console.log(error.response.status);
                  //console.log(error.response.headers);
                  mensaje=error.response.data.message
                  
                  store.addNotification({
                    title: 'Atención',
                    message: mensaje,
                    type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                    container: 'top-right',                // where to position the notifications
                    animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                    animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                    dismiss: {
                      duration: 10000,
                      showIcon:true
                    }
                  })
      
                  this.setState({ loading_btnhisanexo: this.state.loading_btnhisanexo = true })
                  this.setState({ active_btnhisanexo: this.state.active_btnhisanexo = true })
              } else if (error.request) {
                  /*
                   * The request was made but no response was received, `error.request`
                   * is an instance of XMLHttpRequest in the browser and an instance
                   * of http.ClientRequest in Node.js
                   */
                  console.log(error.request);
                  this.setState({ loading_btnhisanexo: this.state.loading_btnhisanexo = true })
                  this.setState({ active_btnhisanexo: this.state.active_btnhisanexo = true })
              } else {
                  // Something happened in setting up the request and triggered an Error
                  console.log('Error', error.message);
                  this.setState({ loading_btnhisanexo: this.state.loading_btnhisanexo = true })
                  this.setState({ active_btnhisanexo: this.state.active_btnhisanexo = true })
              }
              //console.log(error.config);
            
            })
        
      }


      Eliminar_anexo=()=>{
           
            //var  dato  = horario.id;
            //alert(id_cita_cancela);
      
            this.setState({ loading_button_eliminaanexo: this.state.loading_button_eliminaanexo = false })
            this.setState({ active_button_eliminaanexo: this.state.active_button_eliminaanexo = false })
      
            axios.delete(ApiURL+"/api/Attach/Delete/"+id_anexo_elimina)
            .then((response) => {
              console.log(response.data)
                mensaje  = response.data.message;
                //alert(mensaje);
                //const [text, setText] = LocalStorage(text, '')
                //setText(dato);          
                       
                //window.location.href="/home";
                store.addNotification({
                  title: 'Muy bien',
                  message: mensaje,
                  type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                }) 
                
                this.setState({ loading_button_eliminaanexo: this.state.loading_button_eliminaanexo = true })
                this.setState({ active_button_eliminaanexo: this.state.active_button_eliminaanexo = true })
      
                this.Historial_Anexos();
                $('#modal-elimina_anexo').modal('hide');          
               
              
            })
            .catch((error) => {
              if (error.response) {
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                //console.log(error.response.data.message);
                //console.log(error.response.status);
                //console.log(error.response.headers);
                mensaje=error.response.data.message
                
                store.addNotification({
                  title: 'Atención',
                  message: mensaje,
                  type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })
      
                this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = true })
                this.setState({ active_button_eliminaanexo: this.state.active_button_eliminaanexo = true })
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = true })
                this.setState({ active_button_eliminaanexo: this.state.active_button_eliminaanexo = true })
                console.log(error.request);
            } else {
                // Something happened in setting up the request and triggered an Error
                this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = true })
                this.setState({ active_button_eliminaanexo: this.state.active_button_eliminaanexo = true })
                console.log('Error', error.message);
            }
            //console.log(error.config);
            })
      }



      searchDataagenda(buscar_atenciones_idpcte) {

        this.setState({ loading: this.state.loading = false })
        
        axios.get(ApiURL+"/api/Consultations/ListByProfessional/"+institution_id+"?texto="+buscar_atenciones_idpcte)
        .then((response) => {
        console.log(response);

        this.setState({Agendas_inactivas: response.data})

            $('#tabla2').show();
            $('#empty_page2').hide();
            $('#text_page2').hide();


            this.setState({ loading: this.state.loading = true })
        
        })
        .catch((error) => {
          console.log(error);

            $('#tabla2').hide();
            $('#empty_page2').show();
            $('#text_page2').show();   

            this.setState({ loading: this.state.loading = true })
        })
      
      }



    Crear_consulta=async(dato)=>{ 

            axios.put(ApiURL+"/api/Citas/ConfirmPresencialAppointment/"+dato)
            .then((response) => {
              console.log(response.data)
                mensaje  = response.data.message;

                id_consulta=response.data.consultation.id;

                //alert(mensaje);
                //const [text, setText] = LocalStorage(text, '')
                //setText(dato);          
                       
                //window.location.href="/home";
                store.addNotification({
                  title: 'Muy bien',
                  message: mensaje,
                  type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                }) 
                
               
                this.CargarAgendas();
                

              
            })
            .catch((error) => {
              if (error.response) {
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                //console.log(error.response.data.message);
                //console.log(error.response.status);
                //console.log(error.response.headers);
                mensaje=error.response.data.message
                
                store.addNotification({
                  title: 'Atención',
                  message: mensaje,
                  type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })
      
                this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = true })
                this.setState({ active_button_cancelacita: this.state.buttoactive_button_cancelacitan_rta_cita = true })
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = true })
                this.setState({ active_button_cancelacita: this.state.buttoactive_button_cancelacitan_rta_cita = true })
                console.log(error.request);
            } else {
                // Something happened in setting up the request and triggered an Error
                this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = true })
                this.setState({ active_button_cancelacita: this.state.buttoactive_button_cancelacitan_rta_cita = true })
                console.log('Error', error.message);
            }
            //console.log(error.config);
            })
      }

      Cancelar_cita=()=>{
           
            //var  dato  = horario.id;
            //alert(id_cita_cancela);
      
            this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = false })
            this.setState({ active_button_cancelacita: this.state.active_button_cancelacita = false })
      
            axios.put(ApiURL+"/api/Citas/Cancelation/"+id_cita_cancela)
            .then((response) => {
              console.log(response.data)
                mensaje  = response.data.message;
                //alert(mensaje);
                //const [text, setText] = LocalStorage(text, '')
                //setText(dato);          
                       
                //window.location.href="/home";
                store.addNotification({
                  title: 'Muy bien',
                  message: mensaje,
                  type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                }) 
                
                this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = true })
                this.setState({ active_button_cancelacita: this.state.active_button_cancelacita = true })

                this.CargarAgendas();
                $('#modal-cancela_cita').modal('hide');

                // Al cancelar con éxito, se ofrece notificar al paciente por WhatsApp
                // con los mismos datos de la cita que se acaba de cancelar.
                const agendaCancelada = agenda_para_cancelar
                if(agendaCancelada && agendaCancelada.patient && agendaCancelada.patient.user){
                  const nombrePacienteCancelada = [
                    agendaCancelada.patient.user.name1,
                    agendaCancelada.patient.user.name2,
                    agendaCancelada.patient.user.lastname1,
                    agendaCancelada.patient.user.lastname2
                  ].filter(Boolean).map(parte => parte.replace(/\w\S*/g, (w) => w.replace(/^\w/, (c) => c.toUpperCase()))).join(' ')

                  this.setState({
                    formWhatsappCancelacion:{
                      nombre: nombrePacienteCancelada,
                      hora: moment(agendaCancelada.fecha).format('hh:mm A'),
                      fecha: moment(agendaCancelada.fecha).format('DD-MM-YYYY'),
                      especialidad: agendaCancelada.specialty ? agendaCancelada.specialty.name : '',
                      tipoCita: agendaCancelada.type ? (agendaCancelada.type).replace(/\w\S*/g, (w) => w.replace(/^\w/, (c) => c.toUpperCase())) : '',
                      institucion: (sessionStorage.getItem('institution') || '').trim(),
                      celular:''
                    }
                  }, () => {
                    this.Campo_numerico();
                    $('#modal-whatsapp-cancelacion').modal('show');
                  })
                }

            })
            .catch((error) => {
              if (error.response) {
                /*
                 * The request was made and the server responded with a
                 * status code that falls out of the range of 2xx
                 */
                //console.log(error.response.data.message);
                //console.log(error.response.status);
                //console.log(error.response.headers);
                mensaje=error.response.data.message
                
                store.addNotification({
                  title: 'Atención',
                  message: mensaje,
                  type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })
      
                this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = true })
                this.setState({ active_button_cancelacita: this.state.buttoactive_button_cancelacitan_rta_cita = true })
            } else if (error.request) {
                /*
                 * The request was made but no response was received, `error.request`
                 * is an instance of XMLHttpRequest in the browser and an instance
                 * of http.ClientRequest in Node.js
                 */
                this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = true })
                this.setState({ active_button_cancelacita: this.state.buttoactive_button_cancelacitan_rta_cita = true })
                console.log(error.request);
            } else {
                // Something happened in setting up the request and triggered an Error
                this.setState({ loading_button_cancelacita: this.state.loading_button_cancelacita = true })
                this.setState({ active_button_cancelacita: this.state.buttoactive_button_cancelacitan_rta_cita = true })
                console.log('Error', error.message);
            }
            //console.log(error.config);
            })
          }

      handleChangeWhatsappCancelacion = (e) => {
        this.setState({
          formWhatsappCancelacion:{
            ...this.state.formWhatsappCancelacion,
            celular: e.target.value
          }
        })
      }

      /**
       * Notifica por WhatsApp (plantilla "consulta_cancelada") la cancelación de
       * una cita, con los mismos 6 parámetros que en Citas.js, tomados de
       * agenda_para_cancelar (guardada al abrir el modal de cancelar).
       */
      EnviarNotificacionCancelacionWhatsapp = async () => {

        const soloDigitos = this.state.formWhatsappCancelacion.celular.replace(/\D/g,'')

        if(soloDigitos.length==0){
          store.addNotification({
            title: 'Atención',
            message: "Ingresa el número de celular del paciente",
            type: 'danger',
            container: 'top-right',
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 8000, showIcon:true }
          })
          return
        }

        this.setState({ loading_button_whatsapp_cancelacion: this.state.loading_button_whatsapp_cancelacion = false })
        this.setState({ active_button_whatsapp_cancelacion: this.state.active_button_whatsapp_cancelacion = false })

        try{

          await axiosMeta.post(
            "https://graph.facebook.com/v25.0/636239482898096/messages",
            {
              messaging_product: "whatsapp",
              to: "57" + soloDigitos,
              type: "template",
              template: {
                language: { code: "es", policy: "deterministic" },
                name: "consulta_cancelada",
                components: [
                  {
                    type: "body",
                    parameters: [
                      { type: "text", text: this.state.formWhatsappCancelacion.nombre },
                      { type: "text", text: this.state.formWhatsappCancelacion.fecha },
                      { type: "text", text: this.state.formWhatsappCancelacion.hora },
                      { type: "text", text: this.state.formWhatsappCancelacion.especialidad },
                      { type: "text", text: this.state.formWhatsappCancelacion.tipoCita },
                      { type: "text", text: this.state.formWhatsappCancelacion.institucion }
                    ]
                  }
                ]
              }
            },
            {
              headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer EAAZAhYAaHHqUBSV6JDWHMYuiJ9vhNsAgEkQfI6XDvVrG4pCMKuRZBeE0aXiGXXHpZBqPl2hHfgf9qgT5vSIJ4ZBeZAzt34R8HJxlelHrOL95qIcegLRgtseqxdBq7vJ1GoqnVmsbZAEM5EZCHXutFh10eE1Wxr6dwMEyrXh3H261IDm7ZAa68hDtwWLgHxbWdQZDZD"
              }
            }
          )

          store.addNotification({
            title: 'Muy bien',
            message: "Notificación de cancelación enviada por WhatsApp",
            type: 'success',
            container: 'top-right',
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 8000, showIcon:true }
          })

          this.setState({ loading_button_whatsapp_cancelacion: this.state.loading_button_whatsapp_cancelacion = true })
          this.setState({ active_button_whatsapp_cancelacion: this.state.active_button_whatsapp_cancelacion = true })
          $('#modal-whatsapp-cancelacion').modal('hide')

        }catch(error){

          console.log(error.response?.data || error.message)

          store.addNotification({
            title: 'Atención',
            message: "No se pudo enviar la notificación por WhatsApp",
            type: 'danger',
            container: 'top-right',
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 10000, showIcon:true }
          })

          this.setState({ loading_button_whatsapp_cancelacion: this.state.loading_button_whatsapp_cancelacion = true })
          this.setState({ active_button_whatsapp_cancelacion: this.state.active_button_whatsapp_cancelacion = true })
        }
      }

      savehc=async()=>{
      
            if(this.state.form.acompanante.length==0 || this.state.form.tel_acompanante.length==0 || this.state.form.motivo_consulta.length==0 || this.state.form.enfermada_actual.length==0 || this.state.form.antecedentes_rel.length==0 || this.state.form.revision_sistema.length==0 || this.state.form.examen_fis.length==0 || this.state.form.analisis.length==0 || this.state.form.conducta.length==0 ){
      
              store.addNotification({
                title: 'Atención',
                message: "Complete los datos faltantes para continuar.",
                type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                container: 'top-right',                // where to position the notifications
                animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                dismiss: {
                  duration: 10000,
                  showIcon:true
                }
              })
      
            }else{
              this.setState({ loading_button: this.state.loading_button = false })
              this.setState({ active_button: this.state.active_button = false })
              await axios.put(ApiURL+"/api/Consultations/SaveClinicalHistory",
        
                {
                  
                 
              consultationId: id_consulta,
              escort: this.state.form.acompanante,
              phoneEscort: this.state.form.tel_acompanante,
              consultationData: [
                {
                  field: "Motivo de consulta",
                  value: this.state.form.motivo_consulta
                },
                {
                  field: "Enfermedad actual",
                  value: this.state.form.enfermada_actual
                },
                {
                  field: "Antecedentes relevantes",
                  value: this.state.form.antecedentes_rel
                },
                {
                  field: "Revisión por sistemas",
                  value: this.state.form.revision_sistema
                },
                {
                  field: "Examen físico",
                  value: this.state.form.examen_fis
                },
                {
                  field: "Análisis",
                  value: this.state.form.analisis
                },
                {
                  field: "Conducta",
                  value: this.state.form.conducta
                },
                {
                  field: "Fórmula médica",
                  value: this.state.form.formula_med
                },
                {
                  field: "Orden médica",
                  value: this.state.form.orden_med
                }
                
              ],
              diagnostics: diagnosticos_pcte,
              medicalPrescription: [
                {
                  number: 1,
                  medicineName: "Dipirona 2.5 mg",
                  concentration: "2.5 mg",
                  administrationRoute: "Intravenosa",
                  frequencyDose: "cada 8 Horas",
                  duration: "24 Horas",
                  quantities: "3"
                }
              ]
      
                })  
              .then(response=>{
                console.log(response.data)
                var  mensaje  = response.data.message;
                //alert(mensaje);
                //const [text, setText] = LocalStorage(text, '')
                //setText(dato);
                       
                //window.location.href="/home";
              store.addNotification({
                  title: 'Muy bien',
                  message: "La historia clínica fue guardada correctamente.",
                  type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                  duration: 10000,
                  showIcon:true
                  }
                })
      
                this.setState({ loading_button: this.state.loading_button = true })
                this.setState({ active_button: this.state.active_button = true })
      
                this.Consulta_profesional();

                window.location.href="/agenda_profesional"

                this.setState({
              form:{
                  id_cita:'',
                  idconsulta:'', 
                  id_paciente:'',
                  nom_paciente: '',
                  nom2_paciente: '',
                  apell1_paciente: '',
                  apell2_paciente: '',

                  eps:'',

                  acompanante:'',
                  tel_acompanante:'',
                  motivo_consulta:'',
                  enfermada_actual:'',
                  antecedentes_rel:'',
                  revision_sistema:'',
                  examen_fis:'',
                  analisis:'',
                  conducta:'',
                  formula_med:'',
                  orden_med:''
                  
                }
              })
      
                
                
              })
              .catch(error=>{
               
                if (error.response) {
                  /*
                   * The request was made and the server responded with a
                   * status code that falls out of the range of 2xx
                   */
                  //console.log(error.response.data.message);
                  //console.log(error.response.status);
                  //console.log(error.response.headers);
                  mensaje=error.response.data.message
                  
                  store.addNotification({
                    title: 'Atención',
                    message: mensaje,
                    type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                    container: 'top-right',                // where to position the notifications
                    animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                    animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                    dismiss: {
                      duration: 10000,
                      showIcon:true
                    }
                  })
      
                this.setState({ loading_button: this.state.loading_button = true })
                this.setState({ active_button: this.state.active_button = true })
      
              } else if (error.request) {
                  /*
                   * The request was made but no response was received, `error.request`
                   * is an instance of XMLHttpRequest in the browser and an instance
                   * of http.ClientRequest in Node.js
                   */
                  console.log(error.request);
      
                  this.setState({ loading_button: this.state.loading_button = false })
                  this.setState({ loading_button: this.state.active_button = false })
              } else {
                  // Something happened in setting up the request and triggered an Error
                  console.log('Error', error.message);
                  this.setState({ loading_button: this.state.loading_button = true })
                  this.setState({ active_button: this.state.active_button = true })
              }
              //console.log(error.config);
            
              })
      
              }  
            
      
        
      }


      Consulta_profesional(){  

          this.empty_page_hide();
    
          this.setState({ loading: this.state.loading = false })
          axios.get(ApiURL+"/api/Consultations/ListByProfessional/"+institution_id)
          .then((response) => {
    
            console.log(response);
            this.setState({Agendas_inactivas: response.data})
           
    
            if(this.state.Agendas_inactivas.length==0){
    
              $('#tabla2').hide();
              $('#empty_page2').show();
              $('#text_page2').show();   
              
            }else{
    
              $('#tabla2').show();
              $('#empty_page2').hide();
              $('#text_page2').hide(); 
              
            }
    
            this.setState({ loading: this.state.loading = true })
          })
          .catch((error) => {
            console.log(error);
          })
        }


        searchDataagenda_inactiva(buscar_agenda_inactiva) {

          this.setState({ loading: this.state.loading = false })
          
          axios.get(ApiURL+"/api/Schedules/ListInactive?texto="+buscar_agenda_inactiva)
          .then((response) => {
          console.log(response);
  
          this.setState({Agendas_inactivas: response.data.data})
          this.setState({Pager_Agendas_inactivas: response.data.pager.items})
          this.setState({pager_infoagendas_inactivas: response.data.pager.showData})
          
          this.setState({ loading: this.state.loading = true })
          })
          .catch((error) => {
            console.log(error);
          })
        
        }


        loadMoreDataagendas_inactiva(page_agenda_inactiva) {
          var page=page_agenda_inactiva.pagina
          this.setState({ loading: this.state.loading = false })
          
          axios.get(ApiURL+"/api/Schedules/ListInactive?numeroPagina="+page)
          .then((response) => {
    
            console.log(response);
    
            this.setState({Agendas_inactivas: response.data.data})
            this.setState({Pager_Agendas_inactivas: response.data.pager.items})
            this.setState({pager_infoagendas_inactivas: response.data.pager.showData})
      
          
            this.setState({ loading: this.state.loading = true })
          })
          .catch((error) => {
            console.log(error);
          })
        
        }

    handleridservi =  servicios_multi => {      
    
      this.setState({ servicios_multi});
      diagnosticos_pcte=servicios_multi;

      console.log(servicios_multi)  
      
      diagnosticos_pcte = servicios_multi.map(d => ({
              "id" : d.value,
              "name" : d.label.slice(5)
        
            }))

      console.log(diagnosticos_pcte) 
      
      
    }



    render(){ 
      
      const {form} = this.state;

     return (
     
          <div className="content-wrapper">

              <VideoLlamadaZego ref={this.videoLlamadaRef} onLlamadaFinalizada={()=> this.CargarAgendas()}/>

              <div className="col-12 col-sm-12">

                  <div className="row">
            
                      <div className="col-sm-12"> 
                      <br></br>           
                         <div className="text-center" id="title"> <h6> <b> HISTORIAL DE CONSULTA </b>  </h6> </div>            
                      </div>             
            
                  </div>

                  <div className="card card-primary card-outline card-tabs">

                        <div className="card-header p-0 pt-1 border-bottom-0">
                          
                          <ul className="nav nav-tabs" id="custom-tabs-three-tab" role="tablist">
                              
                              <li className="nav-item">
                                <a className="nav-link active" id="custom-tabs-three-profile-tab" data-toggle="pill" href="#custom-tabs-three-profile" role="tab" aria-controls="custom-tabs-three-profile" aria-selected="true" onClick={()=>{this.CargarAgendas()}} >Agenda <Logo_agenda/> </a>
                              </li>
                              <li className="nav-item">
                                <a className="nav-link" id="custom-tabs-three-agenda_inactiva-tab" data-toggle="pill" href="#custom-tabs-three-agenda_inactiva" role="tab" aria-controls="custom-tabs-three-agenda_inactiva" aria-selected="false" onClick={()=>{this.Consulta_profesional()}} >Atendidas <Logo_agenda/> </a>
                              </li>
                              
                          </ul>
                        
                        </div>
                  
                      <div className="card-body">
                        
                          <div className="tab-content" id="custom-tabs-three-tabContent"> 
  

                              <div className="tab-pane fade show active" id="custom-tabs-three-profile" role="tabpanel" aria-labelledby="custom-tabs-three-profile-tab"> 

                                  <div class="d-flex justify-content-center">
                                                
                                      {this.state.loading?false: <ReactBootStrap.Spinner animation="border" />}
                                        
                                  </div>
                                  
                                  <div className="card table-responsive" id="tabla1">    
                                       

                                      <div id="filtrar_agenda" className="row agendapro-toolbar">                                   
                                                                                      
                                          <div className="col-sm-3">
                                              <div className="input-group input-group-sm mb-3 mr-sm-2">                                                      
                                                <select onChange={this.Gettipo_filtro}  className="form-control" id="tipo_filtro" name="tipo_filtro">
                                                    <option  value="0"> Filtrar por...</option>
                                                    <option  value="1"> Modalida de atención</option>
                                                    <option  value="2"> Tipo de consulta</option>
                                                    <option  value="3"> Texto</option>
                                                    <option  value="10"> Limpiar filtro</option>
                                                        
                                                </select>                      
                                              </div>                       
                                          </div>

                                          <div className="col-sm-3" id="texto_filtro">
                                                <div className="input-group input-group-sm mb-3 mr-sm-2">
                                                    <div className="input-group-prepend">
                                                      <div className="input-group-text"><Buscar/></div>
                                                    </div>
                                                    <input type="search" className="form-control" placeholder="Buscar" name="buscar_solicitadas" id="buscar_solicitadas" onChange={this.BuscarSolicitada}/>
                                                </div>                                
                                          </div>

                                          <div className="col-md-3" id="select_modalidad_filtro">                                 
                                              <div className="input-group input-group-sm mb-3 mr-sm-2">                    
                                                        
                                                        <select onChange={this.GetSede_filtro}  className="form-control" id="modalidad_filtro" name="modalidad_filtro">
                                                            <option  value="0"> Todas</option> ,
                                                            <option  value="presencial"> Presencial</option> ,
                                                            <option  value="telemedicina"> Telemedicina</option> ,
                                                                                                                                  
                                                        </select>                   
                                              </div>
                                          </div> 

                                          <div className="col-md-3" id="select_tipoconsulta_filtro">                                 
                                              <div className="input-group input-group-sm mb-3 mr-sm-2">                    
                                                        
                                                        <select onChange={this.GetSede_filtro}  className="form-control" id="tipoconsulta_filtro" name="tipoconsulta_filtro">
                                                            <option  value="0"> Todas</option> ,
                                                            <option  value="999"> Cita particular</option> ,
                                                            <option  value="998"> Examen bexa</option> ,
                                                                                                                                  
                                                        </select>                   
                                              </div>
                                          </div>
                                          
                                      </div>                      
                              
                                        
                                      <div className="agendapro-table-wrap">
                                      <table id="tabla_agendas" className="table table-bordered table-striped table-hover agendapro-table">
                                        <thead>
                                          <tr>
                                            <th>ID</th>
                                            <th>Fecha cita</th>
                                            <th>Paciente</th>
                                            <th>Especialidad</th>

                                            <th>Prestador</th>
                                            <th>Sede</th>
                                            <th>Modalidad de cita</th>
                                            <th>Tipo de cita</th>
                                            <th>Historia clínica</th>
                                            <th>Cancelar</th>
                                          </tr>
                                        </thead>

                                        <tbody>
                                             {this.state.Agendas.map(agenda=>{

                                                    var tipo_cita=agenda.contract ? agenda.contract.entityId : null

                                                          if(tipo_cita=='999'){

                                                            tipo_cita='Cita particular'


                                                          }else{

                                                            if(tipo_cita=='998'){

                                                            tipo_cita='Cita BEXA'


                                                          }else{

                                                             tipo_cita=tipo_cita ? 'Cita por EPS' : 'N/A'

                                                            }

                                                          }

                                               return(

                                               <tr>
                                                 <td>{agenda.id}</td>
                                                 <td>
                                                 {agenda.fecha ? <Moment format="YYYY/MM/DD HH:mm">{agenda.fecha}</Moment> : 'N/A'}
                                                 </td>
                                                 <td>{agenda.patient && agenda.patient.user ? (<React.Fragment>{agenda.patient.user.name1 ? (agenda.patient.user.name1).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : ''} {agenda.patient.user.name2 ? (agenda.patient.user.name2).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '' } { agenda.patient.user.lastname1 ? (agenda.patient.user.lastname1).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '' } { agenda.patient.user.lastname2 ? (agenda.patient.user.lastname2).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '' } <a data-toggle="tooltip" data-placement="top" title="Más información del paciente."  id="btn-registrarse" href="#" onClick={()=>{this.seleccionar_cita(agenda);this.modal_informacionpcte()}} > <spam  > <Info/> </spam> </a></React.Fragment>) : 'N/A'}</td>

                                                 <td>{agenda.specialty && agenda.specialty.name ? (agenda.specialty.name).trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : 'N/A'}</td>
                                                 <td>{agenda.institution && agenda.institution.name ? agenda.institution.name.trim().toUpperCase() : 'N/A'}</td>
                                                 <td>{agenda.schedule && agenda.schedule.sede && agenda.schedule.sede.name ? (agenda.schedule.sede.name).trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : 'N/A'}</td>

                                                 <td>{agenda.type ? (
                                                   <div className="agendapro-modalidad-cell">
                                                     {((agenda.type).trim().toLowerCase()==='telemedicina' && (agenda.state||'').trim().toLowerCase()==='confirmada') ? (
                                                       this.videollamadaHabilitada(agenda) ? (
                                                         <i className="fas fa-video agendapro-modalidad-icono agendapro-modalidad-icono--activo" title="Iniciar videollamada" onClick={(e)=>{e.stopPropagation(); this.videoLlamadaRef.current && this.videoLlamadaRef.current.iniciarLlamada(agenda)}}></i>
                                                       ) : (
                                                         <i className="fas fa-video agendapro-modalidad-icono agendapro-modalidad-icono--inactivo" title="Videollamada no disponible"></i>
                                                       )
                                                     ) : null}
                                                     <div className="agendapro-modalidad-info">
                                                       <span className="agendapro-modalidad-label">{(agenda.type).trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</span>
                                                       {this.estadoUltimaConsulta(agenda) ? (<span className="agendapro-subestado">{(this.estadoUltimaConsulta(agenda)).trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</span>) : null}
                                                     </div>
                                                   </div>
                                                 ) : 'N/A'}</td>
                                                 <td>{tipo_cita}</td>
                                                 {(agenda.type && (agenda.type).trim().toLowerCase()==='telemedicina' && !(agenda.consultations && agenda.consultations.length)) ? (
                                                 <td></td>
                                                 ) : (['atendida','en progreso'].includes((this.estadoUltimaConsulta(agenda)||'').trim().toLowerCase()) ? (
                                                 <td onClick={()=>{this.AbrirModalComoTerminoConsulta(agenda)}}> <BtnEdit title="Realizar historia clínica" />
                                                 </td>
                                                 ) : (
                                                 <td onClick={()=>{this.seleccionarconsulta_agendahc(agenda)}}> <BtnEdit title="Realizar historia clínica" />
                                                 </td>
                                                 ))}
                                                 <td onClick={()=>{this.Traerdato_Cancelar_cita(agenda)}}> <BtnDelete title="Cancelar cita" />  </td>
                                               </tr>
                                               )
                                              }
                                            )}                                                            
                                                                               
                                        </tbody>

                                      </table>
                                      </div>



                                  </div>

                                  <div className="d-flex justify-content-center">
                                        <div id="empty_page" className="estado-vacio__wrap"><EstadoVacio/></div>
                                  </div>

                                  <div className="d-flex justify-content-center">
                                       <h5 id="text_page"> <b>No hay información que mostrar</b> </h5>
                                  </div>

                              </div>

                              <div className="tab-pane fade" id="custom-tabs-three-agenda_inactiva" role="tabpanel" aria-labelledby="custom-tabs-three-agenda_inactiva">

                                  <div className="m24-iframe-fill">
                                      {(this.state.idCitaModalHc && this.state.cargandoIframeAgendaHc) ? (
                                        <div className="m24-iframe-loading">
                                          <ReactBootStrap.Spinner animation="border" />
                                          <span>Cargando historia clínica...</span>
                                        </div>
                                      ) : null}
                                      <iframe
                                        title="Agenda"
                                        src={url_iframe + (this.state.idCitaModalHc ? ("&idCita="+this.state.idCitaModalHc) : "")}
                                        loading="lazy"
                                        allow="microphone"
                                        allowFullScreen
                                        onLoad={()=> this.setState({ cargandoIframeAgendaHc:false })}
                                        >
                                      </iframe>
                                 </div>
                              </div>

                              

                              <div className="tab-pane fade" id="custom-tabs-three-agenda_inactivaa" role="tabpanel" aria-labelledby="custom-tabs-three-agenda_inactivaa"> 

                                  <div className="col-sm-3" id="texto_id_pcteee">
                                        <div className="input-group input-group-sm mb-3 mr-sm-2">
                                            <div className="input-group-prepend">
                                              <div className="input-group-text"><Buscar/></div>
                                            </div>
                                            <input type="search" className="form-control" placeholder="Buscar" name="buscar_solicitadas" id="buscar_solicitadas" onChange={this.Buscar_atenciones_idpcte}/>
                                        </div>                                
                                  </div>

                                  <div className="d-flex justify-content-center">
                                                
                                      {this.state.loading?false: <ReactBootStrap.Spinner animation="border" />}
                                        
                                  </div>
                                  
                                  <div className="card table-responsive" id="tabla2">    
                                       

                                      <div id="filtrar_atendidos" className="row agendapro-toolbar">
                                                                                      
                                          <div className="col-sm-3">
                                              <div className="input-group input-group-sm mb-3 mr-sm-2">                                                      
                                                <select onChange={this.Gettipo_filtro_atendidos}  className="form-control" id="tipo_filtro_atendidos" name="tipo_filtro">
                                                    <option  value="0"> Filtrar por...</option>
                                                    <option  value="1"> Modalida de atención</option>
                                                    <option  value="2"> Tipo de consulta</option>
                                                    <option  value="3"> ID Paciente</option>
                                                    <option  value="10"> Limpiar filtro</option>
                                                        
                                                </select>                      
                                              </div>                       
                                          </div>                                          

                                          <div className="col-md-3" id="select_modalidad_filtro_atendidos">                                 
                                              <div className="input-group input-group-sm mb-3 mr-sm-2">                    
                                                        
                                                        <select onChange={this.GetSede_filtro}  className="form-control" id="modalidad_filtro" name="modalidad_filtro">
                                                            <option  value="0"> Todas</option> ,
                                                            <option  value="presencial"> Presencial</option> ,
                                                            <option  value="telemedicina"> Telemedicina</option> ,
                                                                                                                                  
                                                        </select>                   
                                              </div>
                                          </div> 

                                           <div className="col-md-3" id="select_tipoconsulta_filtro_atendidos">                                 
                                              <div className="input-group input-group-sm mb-3 mr-sm-2">                    
                                                        
                                                        <select onChange={this.GetSede_filtro}  className="form-control" id="tipoconsulta_filtro" name="tipoconsulta_filtro">
                                                            <option  value="0"> Todas</option> ,
                                                            <option  value="999"> Cita particular</option> ,
                                                            <option  value="998"> Examen bexa</option> ,
                                                                                                                                  
                                                        </select>                   
                                              </div>
                                          </div>
                                          
                                      </div>  

                                                          
                              
                                        
                                      <div className="agendapro-table-wrap">
                                      <table id="tabla_agendas_inactivas" className="table table-bordered table-striped table-hover agendapro-table">
                                        <thead>
                                          <tr>
                                            <th>ID consulta</th>
                                            <th>ID cita</th>
                                            <th>Fecha cita</th>
                                            <th>Fecha consulta</th>
                                            <th>Paciente</th>

                                            <th>Prestador</th>
                                            <th>Modalidad de cita</th>
                                            <th>Tipo de cita</th>
                                            <th>Estado de la consulta</th>
                                            <th>Opciones</th>


                                          </tr>
                                        </thead>

                                        <tbody>
                                             {this.state.Agendas_inactivas.map(agenda_inactiva=>{

                                                    var contratoInfo = agenda_inactiva.appointment ? agenda_inactiva.appointment.contract : null
                                                    var tipo_cita = contratoInfo ? contratoInfo.entityId : null

                                                          if(tipo_cita=='999'){

                                                            tipo_cita='Cita particular'


                                                          }else{

                                                            if(tipo_cita=='998'){

                                                            tipo_cita='Cita BEXA'


                                                          }else{

                                                             tipo_cita=tipo_cita ? 'Cita por EPS' : 'N/A'

                                                            }

                                                          }

                                                    var estado_consulta=agenda_inactiva.status
                                                    var btn_estado_consulta=<td></td>

                                                          if(estado_consulta=='atendida' || estado_consulta=='cerrada'){

                                                            estado_consulta='Consulta en progreso'
                                                            btn_estado_consulta=<td data-toggle="tooltip" data-placement="top" title="Terminar historia clínica" onClick={()=>{this.handleModal_realizahc();this.seleccionarconsulta_hc(agenda_inactiva)}}> <BtnEdit title="Realizar historia clínica" /> </td>


                                                          }else{

                                                            if(estado_consulta=='finalizada'){

                                                            estado_consulta='Exitosa'
                                                            btn_estado_consulta=<td  onClick={()=>{this.handleModalconsultashow();this.seleccionarconsulta(agenda_inactiva)}}><BtnVer  /></td>


                                                          }else{

                                                             estado_consulta = estado_consulta ? 'Fallida' : 'N/A'
                                                             btn_estado_consulta=<td data-toggle="tooltip" data-placement="top" title="Terminar historia clínica" onClick={()=>{this.handleModal_realizahc();this.seleccionarconsulta_hc(agenda_inactiva)}}> <BtnEdit title="Realizar historia clínica" /> </td>

                                                            }

                                                          }
                                               return(

                                               <tr key={agenda_inactiva.id}>
                                                 <td>{agenda_inactiva.id}</td>
                                                 <td>{agenda_inactiva.appointmentId}</td>
                                                 <td>
                                                 {agenda_inactiva.appointment && agenda_inactiva.appointment.fecha ? <Moment format="YYYY/MM/DD HH:mm">{agenda_inactiva.appointment.fecha}</Moment> : 'N/A'}
                                                 </td>
                                                  <td>
                                                 {agenda_inactiva.date ? <Moment format="YYYY/MM/DD HH:mm">{agenda_inactiva.date}</Moment> : 'N/A'}
                                                 </td>
                                                 <td>{agenda_inactiva.patient && agenda_inactiva.patient.user ? (<React.Fragment>{agenda_inactiva.patient.user.name1 ? (agenda_inactiva.patient.user.name1).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : ''} {agenda_inactiva.patient.user.name2 ? (agenda_inactiva.patient.user.name2).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '' } { agenda_inactiva.patient.user.lastname1 ? (agenda_inactiva.patient.user.lastname1).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '' } { agenda_inactiva.patient.user.lastname2 ? (agenda_inactiva.patient.user.lastname2).replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '' } <a data-toggle="tooltip" data-placement="top" title="Más información del paciente."  id="btn-registrarse" href="#" onClick={()=>{this.seleccionar_cita2(agenda_inactiva);this.modal_informacionpcte()}} > <spam  > <Info/> </spam> </a></React.Fragment>) : 'N/A'}</td>
                                                 <td>{agenda_inactiva.institution && agenda_inactiva.institution.name ? agenda_inactiva.institution.name.trim().toUpperCase() : 'N/A'}</td>
                                                 <td>{agenda_inactiva.appointment && agenda_inactiva.appointment.type ? (agenda_inactiva.appointment.type).trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : 'N/A'}</td>
                                                 <td>{tipo_cita}</td>
                                                 <td>{estado_consulta}</td>
                                                 {btn_estado_consulta}

                                               </tr>
                                               )
                                              }
                                            )}

                                        </tbody>

                                      </table>
                                      </div>

                                      <div className="agendapro-pagination-bar">
                                      <span className="agendapro-pager-info">{this.state.pager_infoagendas_inactivas}</span>
                                                <nav className="nav agendapro-pagination">

                                                    <ul className="pagination">

                                                        {this.state.Pager_Agendas_inactivas.map(page_agenda_inactiva=>{
                                                        
                                                          var activo=page_agenda_inactiva.activo
                                                          if(activo==true){
                                                            activo='page-item active'
                                                          }else{
                                                            activo='page-item'
                                                          }
              
                                                         // alert(activo)
                                                          
                                                         return(                          
                                                                  
                                                                 <li className={activo}>
                                                                   <a className="nav-link" onClick={()=>{this.loadMoreDataagendas_inactiva(page_agenda_inactiva)}}>{page_agenda_inactiva.texto}</a>
                                                                 </li>                                            
                                                           )
                                                          }
                                                         )
                                                        }

                                                    </ul>

                                                </nav>
                                      </div>

                                  </div>

                                  <div className="d-flex justify-content-center">
                                        <div id="empty_page2" className="estado-vacio__wrap"><EstadoVacio/></div>
                                  </div>

                                  <div className="d-flex justify-content-center">                  
                                       <h5 id="text_page2"> <b>No hay información que mostrar</b> </h5>                          
                                  </div>

                              </div> 
                              
                       
                          </div>

                      </div>
               
                  </div>

              </div>
   
   
   

              <div className="modal fade" id="modal-consulta" data-backdrop="static">
                  <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content citas-respuesta-modal">
                      <div className="modal-header citas-respuesta-modal__header">
                        <h4 className="modal-title citas-respuesta-modal__title"><i className="fas fa-notes-medical"></i> Realizar historia clínica</h4>
                        <button type="button" className="close citas-respuesta-modal__close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true"  onClick={()=> this.handleModalrespuestacitadrop()}>×</span>
                        </button>
                      </div>

                          <div className="modal-body citas-respuesta-modal__body">

                              <div className="citas-form-section">
                                <h6 className="citas-form-section__titulo"><i className="fas fa-id-badge"></i> Datos de la consulta</h6>
                                <div className="row citas-form-row">

                                  <div className="col-md-6">
                                        <div className="form-group">
                                          <label >ID:</label>
                                          <input type="text" className="form-control" name="idconsulta"  value={form.idconsulta} readOnly />
                                        </div>
                                  </div>

                                  <div className="col-md-6">
                                        <div className="form-group">
                                          <label >ID Paciente:</label>
                                          <input type="text" className="form-control" value={form.id_paciente} readOnly />
                                        </div>
                                  </div>

                                  <div className="col-md-6">
                                        <div className="form-group">
                                          <label >Paciente:</label>
                                          <input type="text" className="form-control"  value={form.nom_paciente + ' '+ form.nom2_paciente + ' '+ form.apell1_paciente + ' '+ form.apell2_paciente} readOnly />
                                        </div>
                                  </div>

                                  <div className="col-md-6">
                                      <div className="form-group">
                                              <label >EPS:</label>
                                              <input type="text" className="form-control"  value={form.eps} readOnly/>
                                      </div>
                                  </div>

                                </div>
                              </div>

                              <div className="citas-form-section">
                                <h6 className="citas-form-section__titulo"><i className="fas fa-user-friends"></i> Acompañante</h6>
                                <div className="row citas-form-row">

                                  <div className="col-md-6">
                                        <div className="form-group">
                                          <label >Acompañante:</label>
                                          <input type="text" className="form-control" name="acompanante" onChange={this.handleChange}  />
                                        </div>
                                  </div>

                                  <div className="col-md-6">
                                        <div className="form-group">
                                          <label >Télefono acompañante:</label>
                                          <input type="text" className="form-control" name="tel_acompanante" onChange={this.handleChange} />
                                        </div>
                                  </div>

                                </div>
                              </div>

                              <div className="citas-form-section">
                                <h6 className="citas-form-section__titulo"><i className="fas fa-stethoscope"></i> Historia clínica</h6>
                                <div className="row citas-form-row">

                              <div className="col-md-12">

                                     <div className="form-group">
                                              <label >Motivo de consulta:</label>
                                              <textarea className="form-control" rows="2" name="motivo_consulta" onChange={this.handleChange} > </textarea>
                                      </div>

                              </div>

                              <div className="col-md-12">

                                     <div className="form-group">
                                              <label >Enfermedad actual:</label>
                                              <textarea className="form-control" rows="2" name="enfermada_actual" onChange={this.handleChange} > </textarea>
                                      </div>

                              </div>

                              <div className="col-md-12">

                                     <div className="form-group">
                                              <label >Antecedentes:</label>
                                              <textarea className="form-control" rows="2" name="antecedentes_rel" onChange={this.handleChange} > </textarea>
                                      </div>

                              </div>

                              <div className="col-md-12">

                                     <div className="form-group">
                                              <label >Revisión por sistemas:</label>
                                              <textarea className="form-control" rows="2" name="revision_sistema" onChange={this.handleChange} > </textarea>
                                      </div>

                              </div>

                              <div className="col-md-12">

                                     <div className="form-group">
                                              <label >Examen físico:</label>
                                              <textarea className="form-control" rows="2" name="examen_fis" onChange={this.handleChange} > </textarea>
                                      </div>

                              </div>

                                  <div className="col-md-12">
                                        <div className="form-group">
                                          <label >Diagnoticos:</label>
                                          <Select
                                              options={this.state.Diagnotico_Multiple}
                                              onChange={this.handleridservi}
                                              isMulti
                                              id="especialidad"
                                              className="basic-multi-select"
                                              classNamePrefix="select"
                                              placeholder="Seleccione..."
                                          />
                                        </div>

                                  </div>

                                </div>
                              </div>

                              <div className="citas-form-section">
                                <h6 className="citas-form-section__titulo"><i className="fas fa-clipboard-check"></i> Plan de manejo</h6>
                                <div className="row citas-form-row">

                              <div className="col-md-12">

                                    <div className="form-group">
                                              <label >Análisis:</label>
                                              <textarea className="form-control" rows="2" name="analisis" onChange={this.handleChange} > </textarea>
                                    </div>

                              </div>

                              <div className="col-md-12">

                                    <div className="form-group">
                                              <label >Conducta:</label>
                                              <textarea className="form-control" rows="2" name="conducta" onChange={this.handleChange} > </textarea>
                                    </div>

                              </div>

                              <div className="col-md-12">

                                    <div className="form-group">
                                              <label >Fórmula médica:</label>
                                              <textarea className="form-control" rows="2" name="formula_med" onChange={this.handleChange} > </textarea>
                                    </div>

                              </div>

                              <div className="col-md-12">

                                    <div className="form-group">
                                              <label >Ordenes médicas:</label>
                                              <textarea className="form-control" rows="2" name="orden_med" onChange={this.handleChange} > </textarea>
                                    </div>

                              </div>

                                </div>
                              </div>

                              <div className="citas-form-section">
                                <h6 className="citas-form-section__titulo"><i className="fas fa-paperclip"></i> Cargar anexos</h6>

                              <div className="row citas-form-row" id="seccion_anexo1">

                                <div className="col-md-6">
                                      <div className="form-group">
                                          <label >Profesional que reporta:</label>
                                          <input type="text" className="form-control" name="nom_med_anexo" maxLength="50" autocorrect="off" onChange={this.handleChange} value={nom_med_anexo}  />
                                      </div>
                                </div>

                                <div className="col-md-6">
                                      <div className="form-group">
                                          <label >Identificación del profesional que reporta :</label>
                                          <input type="text" className="form-control" name="id_med_anexo" maxLength="20" autocorrect="off" onChange={this.handleChange} value={id_med_anexo} />
                                      </div>
                                </div>

                              </div>

                              <div className="row citas-form-row" id="seccion_anexo2">

                                <div className="col-md-6">

                                    <div className="form-group">
                                        <label >Tipo de anexo:</label>
                                        <select onChange={this.Get_id_tipoanexo} className="form-control" id="id_tipo_anexo" name="id_tipo_anexo" >
                                            <option  value="0"> Seleccione...</option> ,
                                            {this.state.Tipo_anexos.map(item=>
                                            <option key={item.id} value={item.id}> {item.name.toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</option>
                                            )}

                                        </select>
                                    </div>

                                </div>

                                {/*<div className="col-md-6">
                                      <div className="form-group">
                                          <label >Nombre del anexo:</label>
                                          <input type="text" className="form-control" name="nombre_anexo" maxLength="50" autocorrect="off" onChange={this.handleChange}  />
                                      </div>
                                </div>*/}

                                <div className="row" id="input_file">

                                  <div className="col-md-12 col-auto text-center">

                                      <div className="form-group">

                                          <label >Seleccione un archivo</label>

                                          <div className="custom-file">
                                                <input type="file" name="selectedFile" id="exampleInputFile" multiple="true" className="inputfile inputfile-5" accept=".pdf" onChange={this.GetDoc}/>

                                                <label htmlFor="file-5" for="exampleInputFile">
                                                  <figure>
                                                  <img src={file_pdf}/>
                                                  </figure>
                                                  <span className="iborrainputfile">{this.state.num_file}</span>
                                                </label>
                                          </div>

                                      </div>

                                  </div>

                                </div>

                              </div>

                              {/*<div className="row" id="seccion_anexo3">

                                <div className="col-md-6">
                                      <div className="form-group">
                                            <label >Descripción del anexo:</label>
                                            <textarea className="form-control" rows="4" name="descripcion_anexo" onChange={this.handleChange} > </textarea>
                                      </div>
                                </div>



                              </div>*/}

                              <div className="row citas-form-row">

                                <div className="col-md-12 col-auto text-center">

                                    <button type="button"  className="btn btn-success" disabled={!this.state.active_btnaddanexo} onClick={()=> this.Subir_Anexo()}> {this.state.loading_btnaddanexo?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Subir anexo
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" fill="currentColor" viewBox="0 0 640 640">{/*!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.*/}
                                          <path d="M352 173.3L352 384C352 401.7 337.7 416 320 416C302.3 416 288 401.7 288 384L288 173.3L246.6 214.7C234.1 227.2 213.8 227.2 201.3 214.7C188.8 202.2 188.8 181.9 201.3 169.4L297.3 73.4C309.8 60.9 330.1 60.9 342.6 73.4L438.6 169.4C451.1 181.9 451.1 202.2 438.6 214.7C426.1 227.2 405.8 227.2 393.3 214.7L352 173.3zM320 464C364.2 464 400 428.2 400 384L480 384C515.3 384 544 412.7 544 448L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 448C96 412.7 124.7 384 160 384L240 384C240 428.2 275.8 464 320 464zM464 488C477.3 488 488 477.3 488 464C488 450.7 477.3 440 464 440C450.7 440 440 450.7 440 464C440 477.3 450.7 488 464 488z" />
                                        </svg>
                                    </button>  &nbsp;

                                    <button type="button" id="btn_save" className="btn btn-success" disabled={!this.state.active_btnhisanexo} onClick={()=> this.Historial_Anexos()}> {this.state.loading_btnhisanexo?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Historial de anexos
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1.4em" height="1.4em" fill="currentColor" class="bi bi-card-list" viewBox="-1 0 17 17">
                                          <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"/>
                                          <path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>
                                        </svg>
                                    </button>

                                </div>
                              </div>

                              </div>

                          </div>

                          <div className="modal-footer justify-content-between citas-form-footer">

                                <button type="button" className="btn btn-primary" disabled={!this.state.active_button} onClick={()=> this.savehc()}> {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Guardar
                                  <svg width="1.2em" height="1.2em" viewBox="0 0 16 16" class="bi bi-check2-square" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                      <path fill-rule="evenodd" d="M15.354 2.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L8 9.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                                      <path fill-rule="evenodd" d="M1.5 13A1.5 1.5 0 0 0 3 14.5h10a1.5 1.5 0 0 0 1.5-1.5V8a.5.5 0 0 0-1 0v5a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5h8a.5.5 0 0 0 0-1H3A1.5 1.5 0 0 0 1.5 3v10z"/>
                                  </svg>
                                </button>

                                <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={()=> this.handleModalrespuestacitadrop()}>Cerrar</button>
                          </div>

                    </div>

                  </div>

              </div>


              <div className="modal fade" id="modal-imprimirconsulta" data-backdrop="static">
                  <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content citas-respuesta-modal">
                      <div className="modal-header citas-respuesta-modal__header">
                        <h4 className="modal-title citas-respuesta-modal__title"><i className="fas fa-file-medical-alt"></i> Detalle de consulta</h4>
                        <button type="button" className="close citas-respuesta-modal__close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>

                          <div className="modal-body citas-respuesta-modal__body">

                              <div className="citas-form-section">
                                <h6 className="citas-form-section__titulo"><i className="fas fa-id-badge"></i> Datos generales</h6>
                                <div className="row citas-form-row">

                                  <div className="col-md-6">
                                        <div className="form-group">
                                          <label >ID consulta:</label>
                                          <input type="text" className="form-control"  value={form.idconsulta} readOnly />
                                        </div>
                                  </div>

                                  <div className="col-md-6">
                                        <div className="form-group">
                                          <label >ID Paciente:</label>
                                          <input type="text" className="form-control"  value={form.id_paciente} readOnly />
                                        </div>
                                  </div>

                                  <div className="col-md-6">
                                        <div className="form-group">
                                          <label >Paciente:</label>
                                          <input type="text" className="form-control"  value={form.nom_paciente + ' '+ form.nom2_paciente + ' '+ form.apell1_paciente + ' '+ form.apell2_paciente} readOnly />
                                        </div>
                                  </div>

                                  <div className="col-md-6">
                                      <div className="form-group">
                                              <label >EPS:</label>
                                              <input type="text" className="form-control"  value={form.eps} readOnly/>
                                      </div>
                                  </div>

                                </div>
                              </div>

                              <div className="citas-form-section">
                                <h6 className="citas-form-section__titulo"><i className="fas fa-stethoscope"></i> Historia clínica</h6>
                                    {this.state.Historia.map(histo=>{
                                        return(

                                            <div className="form-group">
                                                    <label >{histo.field}:</label>
                                                    <textarea className="form-control" rows="2" name="nom_medico" value={histo.value} readOnly> </textarea>
                                            </div>

                                          )
                                          }
                                        )
                                    }
                              </div>

                              <div className="citas-form-section">
                                <h6 className="citas-form-section__titulo"><i className="fas fa-diagnoses"></i> Diagnóstico(s)</h6>
                                      <div className="agendapro-table-wrap">
                                                  <table id="tabla_dxhc" className="table table-bordered table-striped table-hover agendapro-table">
                                                    <thead>
                                                      <tr>
                                                        <th>Código diagnóstico</th>
                                                        <th>Nombre diagnóstico</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {this.state.Diagnostico_hc.map(dx_hc=>{

                                                        return(

                                                        <tr>
                                                          <td>{dx_hc.id}</td>
                                                          <td>{(dx_hc.name).toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</td>
                                                        </tr>

                                                            )
                                                          }
                                                        )
                                                      }
                                                    </tbody>
                                                  </table>
                                      </div>
                              </div>

                              <div className="citas-form-section">
                                <h6 className="citas-form-section__titulo"><i className="fas fa-paperclip"></i> Cargar anexos</h6>

                              <div className="row citas-form-row" id="seccion_anexo1">

                                <div className="col-md-6">
                                      <div className="form-group">
                                          <label >Profesional que reporta:</label>
                                          <input type="text" className="form-control" name="nom_med_anexo" maxLength="50" autocorrect="off" onChange={this.handleChange} value={nom_med_anexo}  />
                                      </div>
                                </div>

                                <div className="col-md-6">
                                      <div className="form-group">
                                          <label >Identificación del profesional que reporta :</label>
                                          <input type="text" className="form-control" name="id_med_anexo" maxLength="20" autocorrect="off" onChange={this.handleChange} value={id_med_anexo} />
                                      </div>
                                </div>

                              </div>

                              <div className="row citas-form-row" id="seccion_anexo2">

                                <div className="col-md-6">

                                    <div className="form-group">
                                        <label >Tipo de anexo:</label>
                                        <select onChange={this.Get_id_tipoanexo} className="form-control" id="id_tipo_anexo" name="id_tipo_anexo" >
                                            <option  value="0"> Seleccione...</option> ,
                                            {this.state.Tipo_anexos.map(item=>
                                            <option key={item.id} value={item.id}> {item.name.toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</option>
                                            )}

                                        </select>
                                    </div>

                                </div>

                                {/*<div className="col-md-6">
                                      <div className="form-group">
                                          <label >Nombre del anexo:</label>
                                          <input type="text" className="form-control" name="nombre_anexo" maxLength="50" autocorrect="off" onChange={this.handleChange}  />
                                      </div>
                                </div>*/}

                                <div className="row" id="input_file">

                                  <div className="col-md-12 col-auto text-center">

                                      <div className="form-group">

                                          <label >Seleccione un archivo</label>

                                          <div className="custom-file">
                                                <input type="file" name="selectedFile" id="exampleInputFile" multiple="true" className="inputfile inputfile-5" accept=".pdf" onChange={this.GetDoc}/>

                                                <label htmlFor="file-5" for="exampleInputFile">
                                                  <figure>
                                                  <img src={file_pdf}/>
                                                  </figure>
                                                  <span className="iborrainputfile">{this.state.num_file}</span>
                                                </label>
                                          </div>

                                      </div>

                                  </div>

                                </div>

                              </div>

                              {/*<div className="row" id="seccion_anexo3">

                                <div className="col-md-6">
                                      <div className="form-group">
                                            <label >Descripción del anexo:</label>
                                            <textarea className="form-control" rows="4" name="descripcion_anexo" onChange={this.handleChange} > </textarea>
                                      </div>
                                </div>



                              </div>*/}

                              <div className="row citas-form-row">

                                <div className="col-md-12 col-auto text-center">

                                    <button type="button"  className="btn btn-success" disabled={!this.state.active_btnaddanexo} onClick={()=> this.Subir_Anexo()}> {this.state.loading_btnaddanexo?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Subir anexo
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" fill="currentColor" viewBox="0 0 640 640">{/*!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.*/}
                                          <path d="M352 173.3L352 384C352 401.7 337.7 416 320 416C302.3 416 288 401.7 288 384L288 173.3L246.6 214.7C234.1 227.2 213.8 227.2 201.3 214.7C188.8 202.2 188.8 181.9 201.3 169.4L297.3 73.4C309.8 60.9 330.1 60.9 342.6 73.4L438.6 169.4C451.1 181.9 451.1 202.2 438.6 214.7C426.1 227.2 405.8 227.2 393.3 214.7L352 173.3zM320 464C364.2 464 400 428.2 400 384L480 384C515.3 384 544 412.7 544 448L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 448C96 412.7 124.7 384 160 384L240 384C240 428.2 275.8 464 320 464zM464 488C477.3 488 488 477.3 488 464C488 450.7 477.3 440 464 440C450.7 440 440 450.7 440 464C440 477.3 450.7 488 464 488z" />
                                        </svg>
                                    </button>  &nbsp;

                                    <button type="button" id="btn_save" className="btn btn-success" disabled={!this.state.active_btnhisanexo} onClick={()=> this.Historial_Anexos()}> {this.state.loading_btnhisanexo?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Historial de anexos
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1.4em" height="1.4em" fill="currentColor" class="bi bi-card-list" viewBox="-1 0 17 17">
                                          <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"/>
                                          <path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>
                                        </svg>
                                    </button>

                                </div>
                              </div>

                              </div>

                          </div>

                          <div className="modal-footer justify-content-between citas-form-footer">
                                <div className="btn-group dropup">
                                    <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" disabled={!this.state.active_button}> {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Imprimir
                                            <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                                              <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                                              <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"/>
                                            </svg>
                                    </button>
                                    <div className="dropdown-menu">
                                      <a className="dropdown-item" href="#" onClick={()=> this.descargar_consulta()}>Historia clinica</a>
                                      <a className="dropdown-item" href="#" onClick={()=> this.descargar_formula()}>Formula médica</a>
                                      <a className="dropdown-item" href="#" onClick={()=> this.descargar_orden()}>Orden médica</a>
                                    </div>
                                </div>
                                <button type="button" className="btn btn-success" onClick={()=> this.saverecurso()}> Descargar video
                                  <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" fill="currentColor" class="bi bi-cloud-download" viewBox="0 0 16 16">
                                    <path d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                    <path d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708l3 3z"/>
                                  </svg>
                                </button>

                                <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={()=> this.handleModaldetallehcdrop()}>Cerrar</button>

                          </div>

                    </div>

                  </div>

              </div>


              <div className="modal fade" id="modal-cancela_cita" data-backdrop="static">

                <div className="modal-dialog modal-md modal-dialog-centered">
                  <div className="modal-content cancelar-cita-modal">
                    <div className="modal-header cancelar-cita-modal__header">
                      <button type="button" className="close cancelar-cita-modal__close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                      </button>
                      <div className="cancelar-cita-modal__icono"><i className="fas fa-exclamation-triangle"></i></div>
                      <h4 className="modal-title cancelar-cita-modal__title">Cancelar cita</h4>
                    </div>
                    <div className="modal-body cancelar-cita-modal__body">

                          <p className="cancelar-cita-modal__texto">
                            La cancelación de una cita <b>no se puede revertir</b>.
                          </p>
                          <p className="cancelar-cita-modal__pregunta">¿Seguro que deseas cancelar esta cita?</p>

                    </div>

                          <div className="modal-footer justify-content-between cancelar-cita-modal__footer">
                             <button type="button" className="btn cancelar-cita-modal__btn-mantener" data-dismiss="modal">No, mantener</button>
                             <button type="button" className="btn cancelar-cita-modal__btn-cancelar" data-dismiss="modal"  disabled={!this.state.active_button_cancelacita} onClick={()=> this.Cancelar_cita()}> {this.state.loading_button_cancelacita?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Sí, cancelar</button>
                          </div>
                  </div>
                </div>

              </div>

              <div className="modal fade" id="modal-whatsapp-cancelacion" data-backdrop="static">
                <div className="modal-dialog modal-md">
                  <div className="modal-content citas-respuesta-modal">
                    <div className="modal-header citas-respuesta-modal__header">
                      <h4 className="modal-title citas-respuesta-modal__title"><i className="fab fa-whatsapp"></i> Notificar cancelación por WhatsApp</h4>
                      <button type="button" className="close citas-respuesta-modal__close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body citas-respuesta-modal__body">

                      <div className="citas-form-section">
                        <h6 className="citas-form-section__titulo"><i className="fas fa-calendar-check"></i> Resumen de la cita cancelada</h6>
                        <div className="row citas-form-row">

                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Paciente:</label>
                              <input type="text" className="form-control" value={this.state.formWhatsappCancelacion.nombre} readOnly/>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Especialidad:</label>
                              <input type="text" className="form-control" value={this.state.formWhatsappCancelacion.especialidad} readOnly/>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Fecha:</label>
                              <input type="text" className="form-control" value={this.state.formWhatsappCancelacion.fecha} readOnly/>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Hora:</label>
                              <input type="text" className="form-control" value={this.state.formWhatsappCancelacion.hora} readOnly/>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Tipo de cita:</label>
                              <input type="text" className="form-control" value={this.state.formWhatsappCancelacion.tipoCita} readOnly/>
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Institución:</label>
                              <input type="text" className="form-control" value={this.state.formWhatsappCancelacion.institucion} readOnly/>
                            </div>
                          </div>

                        </div>
                      </div>

                      <div className="citas-form-section">
                        <h6 className="citas-form-section__titulo"><i className="fas fa-mobile-alt"></i> Número de celular del paciente o persona responsable</h6>
                        <div className="row citas-form-row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <div className="input-group">
                                <div className="input-group-prepend">
                                  <span className="input-group-text">+57</span>
                                </div>
                                <input type="text" maxLength="10" className="form-control camponum" placeholder="Ej: 3001234567" name="celular" autoComplete="off" value={this.state.formWhatsappCancelacion.celular} onChange={this.handleChangeWhatsappCancelacion}/>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div className="modal-footer justify-content-between citas-form-footer">
                      <button type="button" className="btn btn-danger" data-dismiss="modal">Cancelar</button>
                      <button type="button" className="btn btn-primary" disabled={!this.state.active_button_whatsapp_cancelacion} onClick={()=> this.EnviarNotificacionCancelacionWhatsapp()}> {this.state.loading_button_whatsapp_cancelacion?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Enviar</button>
                    </div>
                  </div>
                </div>
              </div>

             
              <div className="modal fade" id="modal-infopcte" data-backdrop="static">
                <div className="modal-dialog modal-lg">
                  <div className="modal-content citas-respuesta-modal">
                    <div className="modal-header citas-respuesta-modal__header">
                      <h4 className="modal-title citas-respuesta-modal__title"><i className="fas fa-user-injured"></i> Más información del paciente</h4>
                      <button type="button" className="close citas-respuesta-modal__close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body citas-respuesta-modal__body">

                      <div className="citas-form-section">
                        <h6 className="citas-form-section__titulo"><i className="fas fa-id-badge"></i> Identificación</h6>
                        <div className="row citas-form-row">

                          <div className="col-md-3">
                              <div className="form-group">
                                      <label >Identificación:</label>
                                      <input type="text" className="form-control" id="id_pacie_soli" name="fecha_naci" value={form.id_pacie_soli} readOnly/>
                              </div>
                          </div>

                          <div className="col-md-3">
                              <div className="form-group">
                                      <label >Fecha de nacimiento:</label>
                                      <input type="text" className="form-control" id="fecha_naci" name="fecha_naci" value={form.fecha_naci} readOnly/>
                              </div>
                          </div>

                          <div className="col-md-3">
                              <div className="form-group">
                                      <label >Edad:</label>
                                      <input type="text" className="form-control" id="edad_pcte" name="edad_pcte" value={form.edad_pcte} readOnly/>
                              </div>
                          </div>

                          <div className="col-md-3">
                              <div className="form-group">
                                      <label >Género:</label>
                                      <input type="text"  className="form-control" id="genero_pcte" name="genero_pcte" value={form.genero_pcte} readOnly/>
                              </div>
                          </div>

                        </div>
                      </div>

                      <div className="citas-form-section">
                        <h6 className="citas-form-section__titulo"><i className="fas fa-address-book"></i> Contacto y ubicación</h6>
                        <div className="row citas-form-row">

                          <div className="col-md-6">
                              <div className="form-group">
                                      <label >Teléfono:</label>
                                      <input type="text" className="form-control" id="tel_pcte" name="tel_pcte" value={form.tel_pcte} readOnly/>
                              </div>
                          </div>

                          <div className="col-md-6">
                              <div className="form-group">
                                          <label >Correo eletrónico:</label>
                                          <input type="text" className="form-control" id="email_pcte" name="email_pcte" value={form.email_pcte} readOnly/>
                              </div>
                          </div>

                          <div className="col-md-6">
                              <div className="form-group">
                                      <label >Dirección:</label>
                                      <input type="text"  className="form-control" id="dir_pcte" name="dir_pcte" value={form.dir_pcte} readOnly/>
                              </div>
                          </div>

                          <div className="col-md-3">
                              <div className="form-group">
                                      <label >Municipio:</label>
                                      <input type="text" className="form-control" id="municipio_pcte" name="municipio_pcte" value={form.municipio_pcte} readOnly/>
                              </div>
                          </div>

                          <div className="col-md-3">
                              <div className="form-group">
                                      <label >Departamento:</label>
                                      <input type="text" className="form-control" id="departamento_pct" name="departamento_pct" value={form.departamento_pct} readOnly/>
                              </div>
                          </div>

                        </div>
                      </div>

                      <div className="citas-form-section">
                        <h6 className="citas-form-section__titulo"><i className="fas fa-shield-alt"></i> Aseguramiento</h6>
                        <div className="row citas-form-row">

                          <div className="col-md-6">
                              <div className="form-group">
                                      <label >EPS:</label>
                                      <input type="text" className="form-control" id="eps_pcte" name="eps_pcte" value={form.eps_pcte} readOnly/>
                              </div>
                          </div>

                          <div className="col-md-6">
                              <div className="form-group">
                                      <label >Régimen:</label>
                                      <input type="text" className="form-control" id="regimen_pcte" name="regimen_pcte" value={form.regimen_pcte} readOnly/>
                              </div>
                          </div>

                        </div>
                      </div>

                      <div className="citas-form-section">
                        <h6 className="citas-form-section__titulo"><i className="fas fa-user-friends"></i> Persona responsable</h6>
                        <div className="row citas-form-row">

                          <div className="col-md-6">
                              <div className="form-group">
                                      <label >Persona responsable:</label>
                                      <input type="text" className="form-control" id="responsable_pcte" name="responsable_pcte" value={form.responsable_pcte} readOnly/>
                              </div>
                          </div>

                          <div className="col-md-3">
                              <div className="form-group">
                                      <label >Teléfono:</label>
                                      <input type="text" className="form-control" id="telresponsable_pcte" name="telresponsable_pcte" value={form.telresponsable_pcte} readOnly/>
                              </div>
                          </div>

                          <div className="col-md-3">
                              <div className="form-group">
                                      <label >Parentesco:</label>
                                      <input type="text" className="form-control" id="parentescoresp_pcte" name="regimeparentescoresp_pcten_pcte" value={form.parentescoresp_pcte} readOnly/>
                              </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <div className="modal fade" id="modal-historial_anexo" data-backdrop="static">
                <div className="modal-dialog modal-lg modal-dialog-scrollable" >
                  <div className="modal-content citas-respuesta-modal">
                    <div className="modal-header citas-respuesta-modal__header">
                      <h4 className="modal-title citas-respuesta-modal__title"><i className="fas fa-paperclip"></i> Lista de anexos: {form.nom_paciente +' '+ form.apell1_paciente}</h4>
                      <button type="button" className="close citas-respuesta-modal__close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body citas-respuesta-modal__body">

                          <div className="agendapro-table-wrap">
                              <table id="tabla_historial" className="table table-bordered table-striped table-hover agendapro-table">
                                <thead>
                                  <tr>
                                    <th>ID Anexo</th>
                                    <th>Fecha anexo</th>
                                    <th>Profesional</th>
                                    <th>Nombre anexo</th>
                                    <th>Ver anexo</th>
                                    <th>Eliminar</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.Historial_anexos.map(historial=>{

                                    return(

                                    <tr>
                                      <td>{historial.id}</td>
                                      <td>
                                        <Moment format="YYYY/MM/DD HH:mm">
                                          {historial.date}
                                        </Moment>
                                      </td>
                                      <td>{(historial.profesionalName).toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</td>
                                      <td>{(historial.name).toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</td>
                                      <td>
                                          <a href={process.env.REACT_APP_API_URL+"/api/Files?path="+historial.path} target="_blank">
                                              <button className="btn btn-edit">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" class="bi bi-file-earmark-image" viewBox="0 0 16 16">
                                                  <path d="M6.502 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>
                                                  <path d="M14 14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5V14zM4 1a1 1 0 0 0-1 1v10l2.224-2.224a.5.5 0 0 1 .61-.075L8 11l2.157-3.02a.5.5 0 0 1 .76-.063L13 10V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4z"/>
                                                </svg>
                                              </button>
                                          </a>
                                      </td>
                                      <td onClick={()=>{this.Traerdato_historial_anexo(historial)}}> <BtnDelete />  </td>
                                    </tr>

                                        )
                                      }
                                    )
                                  }
                                </tbody>
                              </table>
                          </div>

                    </div>
                  </div>
                </div>
              </div>

              <div className="modal fade" id="modal-elimina_anexo" data-backdrop="static">

                <div className="modal-dialog modal-md modal-dialog-centered">
                  <div className="modal-content cancelar-cita-modal">
                    <div className="modal-header cancelar-cita-modal__header">
                      <button type="button" className="close cancelar-cita-modal__close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                      </button>
                      <div className="cancelar-cita-modal__icono"><i className="fas fa-trash-alt"></i></div>
                      <h4 className="modal-title cancelar-cita-modal__title">Eliminar anexo</h4>
                    </div>
                    <div className="modal-body cancelar-cita-modal__body">

                          <p className="cancelar-cita-modal__texto">
                            Al eliminar el anexo seleccionado <b>no será posible recuperarlo</b>.
                          </p>
                          <p className="cancelar-cita-modal__pregunta">¿Seguro que deseas eliminar este anexo?</p>

                    </div>

                          <div className="modal-footer justify-content-between cancelar-cita-modal__footer">
                             <button type="button" className="btn cancelar-cita-modal__btn-mantener" data-dismiss="modal">No, mantener</button>
                             <button type="button" className="btn cancelar-cita-modal__btn-cancelar" data-dismiss="modal"  disabled={!this.state.active_button_eliminaanexo} onClick={()=> this.Eliminar_anexo()}> {this.state.loading_button_eliminaanexo?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Sí, eliminar</button>
                          </div>
                  </div>
                </div>

              </div>

              <div className="modal fade" id="modal-hc-iframe" data-backdrop="static">
                <div className="modal-dialog m24-modal-fullscreen">
                  <div className="modal-content m24-modal-fullscreen__content">
                    <div className="modal-header m24-modal-fullscreen__header">
                      <h4 className="modal-title m24-modal-fullscreen__title"><i className="fas fa-notes-medical"></i> Realizar historia clínica</h4>
                      <button type="button" className="close m24-modal-fullscreen__close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body m24-modal-fullscreen__body">
                      <iframe
                        title="Agenda"
                        src={process.env.REACT_APP_IFRAME_URL+"/agenda-profesional-nueva-estructura?token="+token_profesional+"&idProfesional="+id_profeiframe+"&identificacion="+id_med_anexo+"&tokenInstitucion="+token_institucion+"&idInstitucion="+institution_id+"&id_Cita="+this.state.idCitaModalHc}
                        loading="lazy"
                        allow="microphone"
                        allowFullScreen
                        >
                      </iframe>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal fade" id="modal-como-termino-consulta" data-backdrop="static">
                <div className="modal-dialog modal-md modal-dialog-centered">
                  <div className="modal-content consulta-resultado-modal">
                    <button type="button" className="close consulta-resultado-modal__close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">×</span>
                    </button>
                    <div className="modal-body consulta-resultado-modal__body">

                      <div className="consulta-resultado-modal__icono"><i className="fas fa-info-circle"></i></div>
                      <h4 className="consulta-resultado-modal__titulo">¿Cómo terminó la consulta?</h4>

                      <p className="consulta-resultado-modal__texto">
                        Consulta N.º {agenda_finalizar_consulta ? (this.ultimaConsulta(agenda_finalizar_consulta) || {}).id : ''}. La videollamada finalizó; define si fue exitosa o fallida.
                      </p>

                      <p className="consulta-resultado-modal__texto">
                        Es exitosa cuando se pudo atender al paciente y recoger la información necesaria para la historia clínica.
                      </p>
                      <p className="consulta-resultado-modal__texto">
                        Es fallida cuando no se pudo brindar una atención adecuada o no se recogió esa información. Si la marcas como fallida, podrás retomar la comunicación con el paciente en la misma sesión siempre que le llames antes de que pasen 60 minutos desde la desconexión.
                      </p>

                    </div>

                    <div className="modal-footer consulta-resultado-modal__footer">
                      <button type="button" className="btn consulta-resultado-modal__btn-fallida" onClick={()=> this.MarcarConsultaFallida()}>Fallida</button>
                      <button type="button" className="btn consulta-resultado-modal__btn-exitosa" onClick={()=> this.MarcarConsultaExitosa()}>Exitosa</button>
                    </div>
                  </div>
                </div>
              </div>

          </div>
      
    )

  }
  
}

export default Agenda_profesional_2;